<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}">
    <a-alert message="温馨提示：请注意您填写的信息仅适用于签证申请，请如实提供真实信息。" banner closable/>
    <a-card :title="chineseName">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有曾有名" prop="otherName">
            <a-radio-group v-model="form.otherName">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="姓氏(曾有名)" prop="otherSurname">
            <a-input placeholder="例如 li" v-model="form.otherSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="名字(曾有名)" prop="otherGivenName">
            <a-input placeholder="例如 xinan" v-model="form.otherGivenName"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有中文姓名电码" prop="telecodeName">
            <a-radio-group v-model="form.telecodeName">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="身份证号" prop="nationalIdentificationNumber">
            <a-input placeholder="" v-model="form.nationalIdentificationNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.sex">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生省份" prop="provinceOfBirth">
            <a-input placeholder="例如 广东" v-model="form.provinceOfBirth"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生城市" prop="cityOfBirth">
            <a-input placeholder="例如 广州" v-model="form.cityOfBirth"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况" prop="maritalStatus">
            <a-select v-model="form.maritalStatus" placeholder="请选择">
              <a-select-option value="MARRIED">已婚</a-select-option>
              <a-select-option value="COMMON LAW MARRIAGE">普通法律婚姻</a-select-option>
              <a-select-option value="CIVIL UNION/DOMESTIC PARTNERSHIP">民事婚姻/国内同居</a-select-option>
              <a-select-option value="SINGLE">单身</a-select-option>
              <a-select-option value="WIDOWED">丧偶</a-select-option>
              <a-select-option value="DIVORCED">离异</a-select-option>
              <a-select-option value="LEGALLY SEPARATED">合法分居</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.maritalStatus === 'MARRIED' || form.maritalStatus === 'COMMON LAW MARRIAGE' || form.maritalStatus === 'CIVIL UNION/DOMESTIC PARTNERSHIP' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'LEGALLY SEPARATED'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶姓氏" prop="spouseSurname">
            <a-input placeholder="例如 zhang" v-model="form.spouseSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶名字" prop="spouseGivenName">
            <a-input placeholder="例如 san" v-model="form.spouseGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶出生日期" prop="spouseDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.spouseDateOfBirth" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶国籍" prop="spouseCountry">
            <a-select placeholder="请选择" v-model="form.spouseCountry" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in nationList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶出生城市" prop="spouseCityOfBirth">
            <a-input v-model="form.spouseCityOfBirth"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶地址" prop="spouseAddress">
            <a-select v-model="form.spouseAddress" placeholder="请选择">
              <a-select-option value="Same as Home Address">与家庭地址相同</a-select-option>
              <a-select-option value="Same as Mailing Address">与邮寄地址相同</a-select-option>
              <a-select-option value="Same as U.S. Contact Address">与美国联络地址相同</a-select-option>
              <a-select-option value="Do Not Know">不知道</a-select-option>
              <a-select-option value="Other (Specify Address)">其他（请具体说明地址）</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="(form.maritalStatus === 'MARRIED' || form.maritalStatus === 'COMMON LAW MARRIAGE' || form.maritalStatus === 'CIVIL UNION/DOMESTIC PARTNERSHIP' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'LEGALLY SEPARATED') && form.spouseAddress === 'Other (Specify Address)'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶地址省份" prop="spouseAddressOfProvince">
            <a-input placeholder="例如 广东" v-model="form.spouseAddressOfProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶地址城市" prop="spouseAddressOfCity">
            <a-input placeholder="例如 广州" v-model="form.spouseAddressOfCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶地址" prop="spouseAddressOfStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.spouseAddressOfStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶地址邮编" prop="spouseAddressOfZipCode">
            <a-input v-model="form.spouseAddressOfZipCode"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.maritalStatus === 'DIVORCED'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前配偶姓氏" prop="formerSpouseSurname">
            <a-input placeholder="例如 zhang" v-model="form.formerSpouseSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前配偶名字" prop="formerSpouseGivenName">
            <a-input placeholder="例如 san" v-model="form.formerSpouseGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前配偶出生日期" prop="formerSpouseDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.formerSpouseDateOfBirth" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前配偶国籍" prop="formerSpouseCountry">
            <a-select placeholder="请选择" v-model="form.formerSpouseCountry" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in nationList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前配偶出生城市" prop="formerSpouseCityOfBirth">
            <a-input v-model="form.formerSpouseCityOfBirth"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与前配偶结婚日期" prop="formerSpouseStartDate">
            <a-date-picker style="width: 100%" v-model="form.formerSpouseStartDate" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与前配偶离婚日期" prop="formerSpouseEndDate">
            <a-date-picker style="width: 100%" v-model="form.formerSpouseEndDate" :disabled-date="beforeFormerSpouse"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与前配偶离婚原因" prop="formerSpouseHowMarriageEnded">
            <a-input v-model="form.formerSpouseHowMarriageEnded"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.maritalStatus === 'OTHER'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况其他说明" prop="maritalOtherExplain">
            <a-input v-model="form.maritalOtherExplain"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="美国社会安全号" prop="socialSecurityNumber">
            <a-input placeholder="XXX-XX-XXXX" v-model="form.socialSecurityNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="美国缴税号" prop="taxId">
            <a-input placeholder="123456789" v-model="form.taxId"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="他国永居" prop="permanentResidents">
            <a-select mode="multiple"
                      placeholder="请选择"
                      v-model="form.permanentResidents"
                      :filter-option="false"
                      @search="onSearchPermanentResidents"
                      @change="onChangePermanentResidents"
                      @dropdownVisibleChange="onDropdownVisibleChange"
            >
              <a-select-option v-for="(item, index) in countryOptions" :key="index" :value="item.value"
                               :title="item.text">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="获得过美国驾照" prop="hasDriverLicense">
            <a-radio-group v-model="form.hasDriverLicense">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.hasDriverLicense === 'Yes'">
          <a-form-model-item label="美国驾照号码" prop="driverLicenseNumber">
            <a-input placeholder="123456789" v-model="form.driverLicenseNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.hasDriverLicense === 'Yes'">
          <a-form-model-item label="美国驾照所在州" prop="stateOfDriverLicenseNumber">
            <a-select placeholder="请选择" v-model="form.stateOfDriverLicenseNumber" :showSearch="true"
                      optionLabelProp="label">
              <a-select-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

      </a-row>
    </a-card>
    <a-card title="旅行信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签证类型" prop="purposeOfUs">
            <a-select v-model="form.purposeOfUs" placeholder="请选择">
              <a-select-option value="B1-B2">B1/B2</a-select-option>
              <a-select-option value="B1-CF">B1</a-select-option>
              <a-select-option value="B2-TM">B2</a-select-option>
              <a-select-option value="F1-F1">F1</a-select-option>
              <a-select-option value="L1-L1">L1</a-select-option>
              <a-select-option value="L2-CH">CHILD OF A L1 (L2)</a-select-option>
              <a-select-option value="L2-SP">SPOUSE OF A L1 (L2)</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.purposeOfUs === 'L1-L1' || form.purposeOfUs === 'L2-CH' || form.purposeOfUs === 'L2-SP'">
          <a-form-model-item label="申请号" prop="petitionNumber">
            <a-input placeholder="e.g., ABC1234567890" v-model="form.petitionNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.purposeOfUs === 'L2-CH' || form.purposeOfUs === 'L2-SP'">
          <a-form-model-item label="姓氏(申请人)" prop="principleAppSurname">
            <a-input placeholder="例如 li" v-model="form.principleAppSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.purposeOfUs === 'L2-CH' || form.purposeOfUs === 'L2-SP'">
          <a-form-model-item label="名字(申请人)" prop="principleAppGivenName">
            <a-input placeholder="例如 xinan" v-model="form.principleAppGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美停留州" prop="stateOfStay">
            <a-select placeholder="请选择" v-model="form.stateOfStay" :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美停留城市" prop="cityOfStay">
            <a-input placeholder="例如 Stanford" v-model="form.cityOfStay"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美停留地址" prop="streetOfStay">
            <a-input placeholder="例如 450 Serra Mall" v-model="form.streetOfStay"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美停留邮编" prop="zipCodeOfStay">
            <a-input placeholder="例如 94305" v-model="form.zipCodeOfStay"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="有具体旅行计划" prop="travelPlans">
            <a-radio-group v-model="form.travelPlans">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.travelPlans === 'No'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="计划到达日期" prop="intendedDateOfArrival">
            <a-date-picker style="width: 100%" v-model="form.intendedDateOfArrival" :disabled-date="beforeNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="时长(计划停留时间)" prop="intendedLengthOfStayNum">
            <a-input-number :min="1" v-model="form.intendedLengthOfStayNum" style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位(计划停留时间)" prop="intendedLengthOfStayUnit">
            <a-select placeholder="请选择" v-model="form.intendedLengthOfStayUnit">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.travelPlans === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="抵达美国日期" prop="dateOfArrival">
            <a-date-picker style="width: 100%" v-model="form.dateOfArrival" :disabled-date="beforeNow"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="抵达航班" prop="arrivalFlight">
            <a-input v-model="form.arrivalFlight" placeholder="e.g, CZ6666"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="抵达城市" prop="arrivalCity">
            <a-input v-model="form.arrivalCity" placeholder="e.g, Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="离开美国时间" prop="dateOfDeparture">
            <a-date-picker style="width: 100%" v-model="form.dateOfDeparture" :disabled-date="beforeArrival"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="离开航班" prop="departureFlight">
            <a-input v-model="form.departureFlight" placeholder="e.g, CZ6666"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="离开城市" prop="departureCity">
            <a-input v-model="form.departureCity" placeholder="e.g, Stanford"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.travelPlans === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="计划在美旅行城市1" prop="planToLocation1">
            <a-input v-model="form.planToLocation1" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord2 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市2" prop="planToLocation2">
            <a-input v-model="form.planToLocation2" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord3 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市3" prop="planToLocation3">
            <a-input v-model="form.planToLocation3" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord4 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市4" prop="planToLocation4">
            <a-input v-model="form.planToLocation4" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord5 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市5" prop="planToLocation5">
            <a-input v-model="form.planToLocation5" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord6 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市6" prop="planToLocation6">
            <a-input v-model="form.planToLocation6" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord7 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市7" prop="planToLocation7">
            <a-input v-model="form.planToLocation7" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord8 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市8" prop="planToLocation8">
            <a-input v-model="form.planToLocation8" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord9 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市9" prop="planToLocation9">
            <a-input v-model="form.planToLocation9" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord10 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市10" prop="planToLocation10">
            <a-input v-model="form.planToLocation10" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord11 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市11" prop="planToLocation11">
            <a-input v-model="form.planToLocation11" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord12 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市12" prop="planToLocation12">
            <a-input v-model="form.planToLocation12" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord13 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市13" prop="planToLocation13">
            <a-input v-model="form.planToLocation13" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord14 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市14" prop="planToLocation14">
            <a-input v-model="form.planToLocation14" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord15 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市15" prop="planToLocation15">
            <a-input v-model="form.planToLocation15" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord16 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市16" prop="planToLocation16">
            <a-input v-model="form.planToLocation16" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord17 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市17" prop="planToLocation17">
            <a-input v-model="form.planToLocation17" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord18 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市18" prop="planToLocation18">
            <a-input v-model="form.planToLocation18" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord19 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市19" prop="planToLocation19">
            <a-input v-model="form.planToLocation19" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.planToLocationRecord20 === 'Yes'">
          <a-form-model-item label="计划在美旅行城市20" prop="planToLocation20">
            <a-input v-model="form.planToLocation20" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPlanToLocationRecord()"
                    v-if="!form.planToLocationRecord2 || !form.planToLocationRecord3 || !form.planToLocationRecord4 || !form.planToLocationRecord5 || !form.planToLocationRecord6 || !form.planToLocationRecord7 || !form.planToLocationRecord8 || !form.planToLocationRecord9 || !form.planToLocationRecord10 || !form.planToLocationRecord11 || !form.planToLocationRecord12 || !form.planToLocationRecord13 || !form.planToLocationRecord14 || !form.planToLocationRecord15 || !form.planToLocationRecord16 || !form.planToLocationRecord17 || !form.planToLocationRecord18 || !form.planToLocationRecord19 || !form.planToLocationRecord20
                    ||form.planToLocationRecord2 === 'No' || form.planToLocationRecord3 === 'No' ||form.planToLocationRecord4 === 'No' || form.planToLocationRecord5 === 'No' || form.planToLocationRecord6 === 'No' || form.planToLocationRecord7 === 'No' || form.planToLocationRecord8 === 'No' || form.planToLocationRecord9 === 'No' || form.planToLocationRecord10 === 'No' || form.planToLocationRecord11 === 'No' || form.planToLocationRecord12 === 'No' || form.planToLocationRecord13 === 'No' || form.planToLocationRecord14 === 'No' || form.planToLocationRecord15 === 'No' || form.planToLocationRecord16 === 'No' || form.planToLocationRecord17 === 'No' || form.planToLocationRecord18 === 'No' || form.planToLocationRecord19 === 'No' || form.planToLocationRecord20 === 'No'"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removePlanToLocationRecord()"
                    v-if="form.planToLocationRecord2 === 'Yes'|| form.planToLocationRecord3 === 'Yes' || form.planToLocationRecord4 === 'Yes' || form.planToLocationRecord5 === 'Yes'|| form.planToLocationRecord6 === 'Yes'|| form.planToLocationRecord7 === 'Yes'|| form.planToLocationRecord8 === 'Yes'|| form.planToLocationRecord9 === 'Yes'|| form.planToLocationRecord10 === 'Yes'|| form.planToLocationRecord11 === 'Yes'|| form.planToLocationRecord12 === 'Yes'|| form.planToLocationRecord13 === 'Yes'|| form.planToLocationRecord14 === 'Yes'|| form.planToLocationRecord15 === 'Yes'|| form.planToLocationRecord16 === 'Yes'|| form.planToLocationRecord17 === 'Yes'|| form.planToLocationRecord18 === 'Yes'|| form.planToLocationRecord19 === 'Yes' || form.planToLocationRecord20 === 'Yes'"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付旅行费用" prop="payForTrip">
            <a-select v-model="form.payForTrip" placeholder="请选择">
              <a-select-option value="Self">自己</a-select-option>
              <a-select-option value="Other Person">其他人</a-select-option>
              <a-select-option value="Present Employer">Present Employer</a-select-option>
              <a-select-option value="Employer in the U.S.">Employer in the U.S.</a-select-option>
              <a-select-option value="Other Company/Organization">其它公司/组织机构</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.payForTrip === 'Other Person'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人姓氏" prop="surnamesOfPersonPayingForTrip">
            <a-input placeholder="例如 zhang" v-model="form.surnamesOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人名字" prop="givenNamesOfPersonPayingForTrip">
            <a-input placeholder="例如 san" v-model="form.givenNamesOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人的电话" prop="telephoneOfPersonPayingForTrip">
            <a-input v-model="form.telephoneOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人邮件" prop="emailOfPersonPayingForTrip">
            <a-input v-model="form.emailOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人与你关系" prop="relationshipOfPersonPayingForTrip">
            <a-select placeholder="请选择" v-model="form.relationshipOfPersonPayingForTrip">
              <a-select-option value="CHILD">孩子</a-select-option>
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE">夫妻</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与家庭,邮寄地址相同" prop="sameAddressOfPersonPayingForTrip">
            <a-radio-group v-model="form.sameAddressOfPersonPayingForTrip">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.payForTrip === 'Other Person' && form.sameAddressOfPersonPayingForTrip === 'No'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人国家" prop="countryOfPersonPayingForTrip">
            <a-select placeholder="请选择" v-model="form.countryOfPersonPayingForTrip"
                      :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人省份" prop="stateOfPersonPayingForTrip">
            <a-input placeholder="例如 广东" v-model="form.stateOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人城市" prop="cityOfPersonPayingForTrip">
            <a-input placeholder="例如 广州" v-model="form.cityOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人地址" prop="streetOfPersonPayingForTrip">
            <a-input placeholder="例如 中路111号" v-model="form.streetOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付人邮编" prop="zipCodeOfPersonPayingForTrip">
            <a-input placeholder="例如 00000" v-model="form.zipCodeOfPersonPayingForTrip"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.payForTrip === 'Other Company/Organization'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织名称" prop="nameOfCompanyPayingForTrip">
            <a-input placeholder="例如 ***公司" v-model="form.nameOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织与你关系" prop="relationshipOfCompanyPayingForTrip">
            <a-input placeholder="例如 雇佣" v-model="form.relationshipOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织国家" prop="countryOfCompanyPayingForTrip">
            <a-select placeholder="请选择" v-model="form.countryOfCompanyPayingForTrip"
                      :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织省份" prop="provinceOfCompanyPayingForTrip">
            <a-input placeholder="例如 广东" v-model="form.provinceOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织城市" prop="cityOfCompanyPayingForTrip">
            <a-input placeholder="例如 广州" v-model="form.cityOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织地址" prop="streetOfCompanyPayingForTrip">
            <a-input placeholder="例如 中路44444号" v-model="form.streetOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.payForTrip === 'Other Company/Organization'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织邮编" prop="zipCodeOfCompanyPayingForTrip">
            <a-input placeholder="例如 11111" v-model="form.zipCodeOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付组织电话" prop="telephoneOfCompanyPayingForTrip">
            <a-input placeholder="例如 13545214452" v-model="form.telephoneOfCompanyPayingForTrip"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="旅行同伴" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="有同行人" prop="personsTravelingWithYou">
            <a-radio-group v-model="form.personsTravelingWithYou">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.personsTravelingWithYou === 'Yes'">
          <a-form-model-item label="参团出行" prop="partOfOrganization">
            <a-radio-group v-model="form.partOfOrganization">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.personsTravelingWithYou === 'Yes' && form.partOfOrganization ==='Yes'">
          <a-form-model-item label="团队名称" prop="nameOfGroupTravelingWithYou">
            <a-input v-model="form.nameOfGroupTravelingWithYou"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.personsTravelingWithYou === 'Yes'&& form.partOfOrganization === 'No'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓1" prop="surnamesOfPersonTravelingWithYou1">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名1" prop="givenNamesOfPersonTravelingWithYou1">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系1" prop="relationshipWithPersonTravelingWithYou1">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou1" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.personsTravelingWithYouRecord2 || form.personsTravelingWithYouRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPersonsTravelingWithYouRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.personsTravelingWithYou === 'Yes'&& form.partOfOrganization === 'No' && form.personsTravelingWithYouRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓2" prop="surnamesOfPersonTravelingWithYou2">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名2" prop="givenNamesOfPersonTravelingWithYou2">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系2" prop="relationshipWithPersonTravelingWithYou2">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou2" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.personsTravelingWithYouRecord3 || form.personsTravelingWithYouRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPersonsTravelingWithYouRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removePersonsTravelingWithYouRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.personsTravelingWithYou === 'Yes'&& form.partOfOrganization === 'No' && form.personsTravelingWithYouRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓3" prop="surnamesOfPersonTravelingWithYou3">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名3" prop="givenNamesOfPersonTravelingWithYou3">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系3" prop="relationshipWithPersonTravelingWithYou3">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou3" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.personsTravelingWithYouRecord4 || form.personsTravelingWithYouRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPersonsTravelingWithYouRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removePersonsTravelingWithYouRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.personsTravelingWithYou === 'Yes'&& form.partOfOrganization === 'No' && form.personsTravelingWithYouRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓4" prop="surnamesOfPersonTravelingWithYou4">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名4" prop="givenNamesOfPersonTravelingWithYou4">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系4" prop="relationshipWithPersonTravelingWithYou4">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou4" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.personsTravelingWithYouRecord5 || form.personsTravelingWithYouRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPersonsTravelingWithYouRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removePersonsTravelingWithYouRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.personsTravelingWithYou === 'Yes'&& form.partOfOrganization === 'No' && form.personsTravelingWithYouRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓5" prop="surnamesOfPersonTravelingWithYou5">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名5" prop="givenNamesOfPersonTravelingWithYou5">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系5" prop="relationshipWithPersonTravelingWithYou5">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou5" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.personsTravelingWithYouRecord6 || form.personsTravelingWithYouRecord6 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPersonsTravelingWithYouRecord(6)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removePersonsTravelingWithYouRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.personsTravelingWithYou === 'Yes' && form.partOfOrganization === 'No' && form.personsTravelingWithYouRecord6 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓6" prop="surnamesOfPersonTravelingWithYou6">
            <a-input v-model="form.surnamesOfPersonTravelingWithYou6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名6" prop="givenNamesOfPersonTravelingWithYou6">
            <a-input v-model="form.givenNamesOfPersonTravelingWithYou6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系6" prop="relationshipWithPersonTravelingWithYou6">
            <a-select v-model="form.relationshipWithPersonTravelingWithYou6" placeholder="请选择">
              <a-select-option value="PARENT">父母</a-select-option>
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="OTHER RELATIVE">其他亲属</a-select-option>
              <a-select-option value="FRIEND">朋友</a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">商业伙伴</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removePersonsTravelingWithYouRecord(6)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="以往赴美旅行信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美国停留过" prop="beanInUs">
            <a-radio-group v-model="form.beanInUs">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.beanInUs === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往抵美日期1" prop="dateArrivedVisits1">
            <a-date-picker style="width: 100%" v-model="form.dateArrivedVisits1" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美时长1" prop="numLengthOfStayVisits1">
            <a-input-number :min="1" v-model="form.numLengthOfStayVisits1"
                            style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美单位1" prop="unitLengthOfStayVisits1">
            <a-select v-model="form.unitLengthOfStayVisits1" placeholder="请选择">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.beanInUsRecord2 || form.beanInUsRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addBeanInUsRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.beanInUs === 'Yes' && form.beanInUsRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往抵美日期2" prop="dateArrivedVisits2">
            <a-date-picker style="width: 100%" v-model="form.dateArrivedVisits2" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美时长2" prop="numLengthOfStayVisits2">
            <a-input-number :min="1" v-model="form.numLengthOfStayVisits2"
                            style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美单位2" prop="unitLengthOfStayVisits2">
            <a-select placeholder="请选择" v-model="form.unitLengthOfStayVisits2">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.beanInUsRecord3 || form.beanInUsRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addBeanInUsRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeBeanInUsRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.beanInUs === 'Yes' && form.beanInUsRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往抵美日期3" prop="dateArrivedVisits3">
            <a-date-picker style="width: 100%" v-model="form.dateArrivedVisits3" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美时长3" prop="numLengthOfStayVisits3">
            <a-input-number :min="1" v-model="form.numLengthOfStayVisits3"
                            style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美单位3" prop="unitLengthOfStayVisits3">
            <a-select placeholder="请选择" v-model="form.unitLengthOfStayVisits3">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.beanInUsRecord4 || form.beanInUsRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addBeanInUsRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeBeanInUsRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.beanInUs === 'Yes' && form.beanInUsRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往抵美日期4" prop="dateArrivedVisits4">
            <a-date-picker style="width: 100%" v-model="form.dateArrivedVisits4" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美时长4" prop="numLengthOfStayVisits4">
            <a-input-number :min="1" v-model="form.numLengthOfStayVisits4"
                            style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美单位4" prop="unitLengthOfStayVisits4">
            <a-select placeholder="请选择" v-model="form.unitLengthOfStayVisits4">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.beanInUsRecord5 || form.beanInUsRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addBeanInUsRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeBeanInUsRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.beanInUs === 'Yes' && form.beanInUsRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往抵美日期5" prop="dateArrivedVisits5">
            <a-date-picker style="width: 100%" v-model="form.dateArrivedVisits5" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美时长5" prop="numLengthOfStayVisits5">
            <a-input-number :min="1" v-model="form.numLengthOfStayVisits5"
                            style="width: 100%; "/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="以往在美单位5" prop="unitLengthOfStayVisits5">
            <a-select placeholder="请选择" v-model="form.unitLengthOfStayVisits5">
              <a-select-option v-for="item in unitTimeList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeBeanInUsRecord(5)"/>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="获得过美国签证" prop="issuedUsVisa">
            <a-radio-group v-model="form.issuedUsVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.issuedUsVisa === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="最近获得签证时间" prop="previousDateLastVisaWasIssued">
            <a-date-picker style="width: 100%" v-model="form.previousDateLastVisaWasIssued" value-format="YYYY-MM-DD"
                           :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签证号码" prop="previousVisaNumber">
            <a-input v-model="form.previousVisaNumber"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同一类型签证" prop="sameVisa">
            <a-radio-group v-model="form.sameVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.issuedUsVisa === 'Yes'">
          <a-form-model-item label="同一国家或地区" prop="sameCountry">
            <a-radio-group v-model="form.sameCountry">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="采过十指指纹" prop="tenPrinted">
            <a-radio-group v-model="form.tenPrinted">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.issuedUsVisa === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签证曾经遗失或被盗" prop="lostStolenVisa">
            <a-radio-group v-model="form.lostStolenVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.lostStolenVisa === 'Yes'">
          <a-form-model-item label="签证丢失年份" prop="lostStolenVisaYear">
            <a-select placeholder="请选择" v-model="form.lostStolenVisaYear">
              <a-select-option v-for="item in yearList" :key="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.lostStolenVisa === 'Yes'">
          <a-form-model-item label="签证丢失说明" prop="lostStolenVisaExplain">
            <a-input v-model="form.lostStolenVisaExplain"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="美国签证被撤销过" prop="cancelledRevokedVisa">
            <a-radio-group v-model="form.cancelledRevokedVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.cancelledRevokedVisa === 'Yes'">
          <a-form-model-item label="签证撤销说明" prop="cancelledRevokedVisaExplain">
            <a-input v-model="form.cancelledRevokedVisaExplain"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拒签,入境或撤回入境" prop="refusedVisa">
            <a-radio-group v-model="form.refusedVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.refusedVisa === 'Yes'">
          <a-form-model-item label="拒签,入境或撤入境" prop="refusedVisaExplain">
            <a-textarea placeholder="请说明" v-model="form.refusedVisaExplain" auto-size/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="申请办理过移民" prop="behalfWithImmigration">
            <a-radio-group v-model="form.behalfWithImmigration">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.behalfWithImmigration === 'Yes'">
          <a-form-model-item label="移民原因" prop="behalfWithImmigrationExplain">
            <a-textarea placeholder="请说明" v-model="form.behalfWithImmigrationExplain" auto-size/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="联系信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址省份" prop="homeAddressForProvince">
            <a-input placeholder="例如 广东" v-model="form.homeAddressForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址城市" prop="homeAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址" prop="homeAddressForStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址邮编" prop="homeAddressForZipCode">
            <a-input placeholder="例如 00000" v-model="form.homeAddressForZipCode"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与邮寄地址相同" prop="sameHomeAddress">
            <a-radio-group v-model="form.sameHomeAddress">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.sameHomeAddress === 'No'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮寄地址省份" prop="mailingAddressForProvince">
            <a-input placeholder="例如 广东" v-model="form.mailingAddressForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮寄地址城市" prop="mailingAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.mailingAddressForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮寄地址" prop="mailingAddressForAddress">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.mailingAddressForAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮寄地址邮编" prop="mailingAddressForZipCode">
            <a-input placeholder="例如 00000" v-model="form.mailingAddressForZipCode"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="primaryPhoneNumber">
            <a-input placeholder="例如 13900000000" v-model="form.primaryPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭电话" prop="secondaryPhoneNumber">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.secondaryPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="工作电话" prop="workPhoneNumber">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.workPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他电话" prop="otherPhoneNumber">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.otherPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现用电子邮箱" prop="emailAddress">
            <a-input placeholder="例如 654431151@qq.com" v-model="form.emailAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他电子邮箱1" prop="otherEmailAddress">
            <a-input placeholder="例如 654431151@qq.com" v-model="form.otherEmailAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他电子邮箱2" prop="otherEmailAddress2">
            <a-input placeholder="例如 654431151@qq.com" v-model="form.otherEmailAddress2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他电子邮箱3" prop="otherEmailAddress3">
            <a-input placeholder="例如 654431151@qq.com" v-model="form.otherEmailAddress3"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台" prop="socialMedia">
            <a-radio-group v-model="form.socialMedia">
              <a-radio value="Yes">有</a-radio>
              <a-radio value="No">没</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台1" prop="socialMediaPlatform1">
            <a-select v-model="form.socialMediaPlatform1" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号1" prop="socialMediaAccount1">
            <a-input v-model="form.socialMediaAccount1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord2 || form.socialMediaRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台2" prop="socialMediaPlatform2">
            <a-select v-model="form.socialMediaPlatform2" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号2" prop="socialMediaAccount2">
            <a-input v-model="form.socialMediaAccount2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord3 || form.socialMediaRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台3" prop="socialMediaPlatform3">
            <a-select v-model="form.socialMediaPlatform3" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号3" prop="socialMediaAccount3">
            <a-input v-model="form.socialMediaAccount3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord4 || form.socialMediaRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台4" prop="socialMediaPlatform4">
            <a-select v-model="form.socialMediaPlatform4" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号4" prop="socialMediaAccount4">
            <a-input v-model="form.socialMediaAccount4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord5 || form.socialMediaRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台5" prop="socialMediaPlatform5">
            <a-select v-model="form.socialMediaPlatform5" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号5" prop="socialMediaAccount5">
            <a-input v-model="form.socialMediaAccount5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord6 || form.socialMediaRecord6 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(6)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord6 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台6" prop="socialMediaPlatform6">
            <a-select v-model="form.socialMediaPlatform6" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号6" prop="socialMediaAccount6">
            <a-input v-model="form.socialMediaAccount6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord7 || form.socialMediaRecord7 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(7)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(6)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord7 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台7" prop="socialMediaPlatform7">
            <a-select v-model="form.socialMediaPlatform7" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号7" prop="socialMediaAccount7">
            <a-input v-model="form.socialMediaAccount7"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord8 || form.socialMediaRecord8 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(8)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(7)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord8 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台8" prop="socialMediaPlatform8">
            <a-select v-model="form.socialMediaPlatform8" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号8" prop="socialMediaAccount8">
            <a-input v-model="form.socialMediaAccount8"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.socialMediaRecord9 || form.socialMediaRecord9 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSocialMediaRecord(9)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(8)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.socialMedia === 'Yes' && form.socialMediaRecord9 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台9" prop="socialMediaPlatform9">
            <a-select v-model="form.socialMediaPlatform9" placeholder="请选择">
              <a-select-option v-for="item in socialMediaList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号9" prop="socialMediaAccount9">
            <a-input v-model="form.socialMediaAccount9"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSocialMediaRecord(9)"/>
          </a-form-model-item>
        </a-col>
      </a-row>


      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他社交平台" prop="otherSocialMedia">
            <a-radio-group v-model="form.otherSocialMedia">
              <a-radio value="Yes">有</a-radio>
              <a-radio value="No">没</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台1" prop="otherSocialMediaPlatform1">
            <a-input v-model="form.otherSocialMediaPlatform1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号1" prop="otherSocialMediaAccount1">
            <a-input v-model="form.otherSocialMediaAccount1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord2 || form.otherSocialMediaRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台2" prop="otherSocialMediaPlatform2">
            <a-input v-model="form.otherSocialMediaPlatform2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号2" prop="otherSocialMediaAccount2">
            <a-input v-model="form.otherSocialMediaAccount2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord3 || form.otherSocialMediaRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台3" prop="otherSocialMediaPlatform3">
            <a-input v-model="form.otherSocialMediaPlatform3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号3" prop="otherSocialMediaAccount3">
            <a-input v-model="form.otherSocialMediaAccount3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord4 || form.otherSocialMediaRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台4" prop="otherSocialMediaPlatform4">
            <a-input v-model="form.otherSocialMediaPlatform4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号4" prop="otherSocialMediaAccount4">
            <a-input v-model="form.otherSocialMediaAccount4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord5 || form.otherSocialMediaRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台5" prop="otherSocialMediaPlatform5">
            <a-input v-model="form.otherSocialMediaPlatform5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号5" prop="otherSocialMediaAccount5">
            <a-input v-model="form.otherSocialMediaAccount5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord6 || form.otherSocialMediaRecord6 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(6)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord6 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台6" prop="otherSocialMediaPlatform6">
            <a-input v-model="form.otherSocialMediaPlatform6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号6" prop="otherSocialMediaAccount6">
            <a-input v-model="form.otherSocialMediaAccount6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord7 || form.otherSocialMediaRecord7 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(7)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(6)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord7 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台7" prop="otherSocialMediaPlatform7">
            <a-input v-model="form.otherSocialMediaPlatform7"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号7" prop="otherSocialMediaAccount7">
            <a-input v-model="form.otherSocialMediaAccount7"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord8 || form.otherSocialMediaRecord8 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(8)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(7)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord8 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台8" prop="otherSocialMediaPlatform8">
            <a-input v-model="form.otherSocialMediaPlatform8"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号8" prop="otherSocialMediaAccount8">
            <a-input v-model="form.otherSocialMediaAccount8"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.otherSocialMediaRecord9 || form.otherSocialMediaRecord9 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addOtherSocialMediaRecord(9)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(8)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.otherSocialMedia === 'Yes' && form.otherSocialMediaRecord9 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交平台9" prop="otherSocialMediaPlatform9">
            <a-input v-model="form.otherSocialMediaPlatform9"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="社交账号9" prop="otherSocialMediaAccount9">
            <a-input v-model="form.otherSocialMediaAccount9"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeOtherSocialMediaRecord(9)"/>
          </a-form-model-item>
        </a-col>
      </a-row>


    </a-card>
    <a-card title="护照信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照类型" prop="passportType">
            <a-select v-model="form.passportType" placeholder="请选择">
              <a-select-option value="REGULAR">普通</a-select-option>
              <a-select-option value="OFFICIAL">公务</a-select-option>
              <a-select-option value="DIPLOMATIC">外交</a-select-option>
              <a-select-option value="LAISSEZ-PASSER">Laissez-Passer</a-select-option>
              <a-select-option value="OTHER">因公普通护照 ，其它</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.passportType === 'OTHER'">
          <a-form-model-item label="护照说明" prop="passportExplain">
            <a-input placeholder="例如 护照说明" v-model="form.passportExplain"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签发省" prop="provinceForPassport">
            <a-input placeholder="例如 广东" v-model="form.provinceForPassport"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签发城市" prop="cityForPassport">
            <a-input placeholder="例如 广州" v-model="form.cityForPassport"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签发日期" prop="issuanceDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.issuanceDateForPassport" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="失效日期" prop="expirationDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.expirationDateForPassport" value-format="YYYY-MM-DD"
                           :disabled-date="beforeExpiration"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照遗失或被盗过" prop="lostStolenPassport">
            <a-radio-group v-model="form.lostStolenPassport">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.lostStolenPassport === 'Yes'">
          <a-form-model-item label="遗失护照号" prop="numberForLostStolenPassport">
            <a-input placeholder="例如 EC5808155" v-model="form.numberForLostStolenPassport"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.lostStolenPassport === 'Yes'">
          <a-form-model-item label="遗失护照说明" prop="explainForLostStolenPassport">
            <a-input v-model="form.explainForLostStolenPassport"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照本编号" prop="passportBookNumber">
            <a-input placeholder="例如 1462600000" v-model="form.passportBookNumber"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="在美联系人信息(旅行社代填)" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系方式" prop="relationshipMethod">
            <a-select v-model="form.relationshipMethod" placeholder="请选择">
              <a-select-option value="person">联系人</a-select-option>
              <a-select-option value="organization">联系组织</a-select-option>
              <a-select-option value="personAndOrganization">联系人和组织</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.relationshipMethod === 'person' || form.relationshipMethod === 'personAndOrganization'">
          <a-form-model-item label="联系人姓氏" prop="surnamesForContactPerson">
            <a-input placeholder="例如 li" v-model="form.surnamesForContactPerson"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.relationshipMethod === 'person' || form.relationshipMethod === 'personAndOrganization'">
          <a-form-model-item label="联系人名字" prop="givenNamesForContactPerson">
            <a-input placeholder="例如 san" v-model="form.givenNamesForContactPerson"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.relationshipMethod === 'organization' || form.relationshipMethod === 'personAndOrganization'">
          <a-form-model-item label="组织名称" prop="organizationForContactPerson">
            <a-auto-complete
                v-if="hotelList && hotelList.length > 0" v-model="form.organizationForContactPerson"
                placeholder="e.g, hotel"
                :data-source="hotelList"
                style="width: 100%"
                :filter-option="filterHotelOption"
                @select="onSelectHotel"
            />
            <a-input v-else v-model="form.organizationForContactPerson" placeholder="e.g, apple"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.relationshipMethod">
          <a-form-model-item label="与你关系" prop="relationshipToYou">
            <a-select v-model="form.relationshipToYou" placeholder="请选择">
              <a-select-option value="RELATIVE"
                               v-if="form.relationshipMethod === 'person' || form.relationshipMethod === 'personAndOrganization'">
                亲属
              </a-select-option>
              <a-select-option value="SPOUSE"
                               v-if="form.relationshipMethod === 'person' || form.relationshipMethod === 'personAndOrganization'"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="FRIEND"
                               v-if="form.relationshipMethod === 'person' || form.relationshipMethod === 'personAndOrganization'">
                朋友
              </a-select-option>
              <a-select-option value="BUSINESS ASSOCIATE">公司合伙方</a-select-option>
              <a-select-option value="EMPLOYER">雇主(组织)</a-select-option>
              <a-select-option value="SCHOOL OFFICIAL">学校官员(组织)</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="所在州" prop="stateOfContact">
            <a-select v-model="form.stateOfContact" placeholder="请选择" :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="所在城市" prop="cityOfContact">
            <a-input v-model="form.cityOfContact" placeholder="例如 Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="所在地址" prop="streetOfContact">
            <a-input v-model="form.streetOfContact" placeholder="例如 450 Serra Mall"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="所在地址邮编" prop="zipCodeOfContact">
            <a-input v-model="form.zipCodeOfContact" placeholder="例如 55555"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人手机" prop="phoneOfContact">
            <a-input v-model="form.phoneOfContact" placeholder="例如 16507232300"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人邮箱" prop="emailOfContact">
            <a-input v-model="form.emailOfContact" placeholder="例如 visitorinfo@stanford.edu"/>
          </a-form-model-item>
        </a-col>

      </a-row>
    </a-card>
    <a-card title="家庭信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲姓氏" prop="fatherSurnames">
            <a-input v-model="form.fatherSurnames" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲名字" prop="fatherGivenNames">
            <a-input v-model="form.fatherGivenNames" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲出生日期" prop="fatherDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.fatherDateOfBirth" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="afterBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲是否在美国" prop="fatherInUs">
            <a-radio-group v-model="form.fatherInUs">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.fatherInUs === 'Yes'">
          <a-form-model-item label="父亲在美国移民身份" prop="fatherStatus">
            <a-select placeholder="请选择" v-model="form.fatherStatus">
              <a-select-option v-for="item in usStatusList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲姓氏" prop="motherSurnames">
            <a-input v-model="form.motherSurnames" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲名字" prop="motherGivenNames">
            <a-input v-model="form.motherGivenNames" placeholder="例如 si"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲出生日期" prop="motherDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.motherDateOfBirth" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="afterBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲是否在美国" prop="motherInUs">
            <a-radio-group v-model="form.motherInUs">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.motherInUs === 'Yes'">
          <a-form-model-item label="母亲在美国是否移民身份" prop="motherStatus">
            <a-select placeholder="请选择" v-model="form.motherStatus">
              <a-select-option v-for="item in usStatusList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直系亲属在美" prop="immediateRelatives">
            <a-radio-group v-model="form.immediateRelatives">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.immediateRelatives === 'No'">
          <a-form-model-item label="非直系亲属在美" prop="otherRelatives">
            <a-radio-group v-model="form.otherRelatives">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.immediateRelatives === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属姓氏1" prop="immediateRelativesSurnames1">
            <a-input v-model="form.immediateRelativesSurnames1" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属名字1" prop="immediateRelativesGivenNames1">
            <a-input v-model="form.immediateRelativesGivenNames1" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与您的关系1" prop="immediateRelativesRelationship1">
            <a-select v-model="form.immediateRelativesRelationship1" placeholder="请选择">
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="FIANCÉ/FIANCÉE">未婚夫/妻</a-select-option>
              <a-select-option value="CHILD">子女</a-select-option>
              <a-select-option value="SIBLING">兄弟姐妹</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="移民身份1" prop="immediateRelativesRelativeStatus1">
            <a-select v-model="form.immediateRelativesRelativeStatus1" placeholder="请选择">
              <a-select-option value="U.S. CITIZEN">U.S. CITIZEN</a-select-option>
              <a-select-option value="U.S. LEGAL PERMANENT RESIDENT (LPR)">U.S. LEGAL PERMANENT RESIDENT (LPR)
              </a-select-option>
              <a-select-option value="NONIMMIGRANT">NONIMMIGRANT</a-select-option>
              <a-select-option value="OTHER/I DON'T KNOW">OTHER/I DON'T KNOW</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.immediateRelativesRecord2 || form.immediateRelativesRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addImmediateRelativesRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.immediateRelatives === 'Yes' && form.immediateRelativesRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属姓氏2" prop="immediateRelativesSurnames2">
            <a-input v-model="form.immediateRelativesSurnames2" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属名字2" prop="immediateRelativesGivenNames2">
            <a-input v-model="form.immediateRelativesGivenNames2" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与您的关系2" prop="immediateRelativesRelationship2">
            <a-select v-model="form.immediateRelativesRelationship2" placeholder="请选择">
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="FIANCÉ/FIANCÉE">未婚夫/妻</a-select-option>
              <a-select-option value="CHILD"> 子女</a-select-option>
              <a-select-option value="SIBLING"> 兄弟姐妹</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="移民身份2" prop="immediateRelativesRelativeStatus2">
            <a-select v-model="form.immediateRelativesRelativeStatus2" placeholder="请选择">
              <a-select-option value="U.S. CITIZEN">U.S. CITIZEN</a-select-option>
              <a-select-option value="U.S. LEGAL PERMANENT RESIDENT (LPR)">U.S. LEGAL PERMANENT RESIDENT (LPR)
              </a-select-option>
              <a-select-option value="NONIMMIGRANT">NONIMMIGRANT</a-select-option>
              <a-select-option value="OTHER/I DON'T KNOW">OTHER/I DON'T KNOW</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.immediateRelativesRecord3 || form.immediateRelativesRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addImmediateRelativesRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeImmediateRelativesRecord(2)"/>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row class="form-row" v-if="form.immediateRelatives === 'Yes'  && form.immediateRelativesRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属姓氏3" prop="immediateRelativesSurnames3">
            <a-input v-model="form.immediateRelativesSurnames3" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="直属亲属名字3" prop="immediateRelativesGivenNames3">
            <a-input v-model="form.immediateRelativesGivenNames3" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与您的关系3" prop="immediateRelativesRelationship3">
            <a-select v-model="form.immediateRelativesRelationship3" placeholder="请选择">
              <a-select-option value="SPOUSE"
                               :disabled="form.maritalStatus === 'SINGLE' || form.maritalStatus === 'WIDOWED'|| form.maritalStatus === 'DIVORCED'">
                配偶
              </a-select-option>
              <a-select-option value="FIANCÉ/FIANCÉE">未婚夫/妻</a-select-option>
              <a-select-option value="CHILD"> 子女</a-select-option>
              <a-select-option value="SIBLING"> 兄弟姐妹</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="移民身份3" prop="immediateRelativesRelativeStatus3">
            <a-select v-model="form.immediateRelativesRelativeStatus3" placeholder="请选择">
              <a-select-option value="U.S. CITIZEN">U.S. CITIZEN</a-select-option>
              <a-select-option value="U.S. LEGAL PERMANENT RESIDENT (LPR)">U.S. LEGAL PERMANENT RESIDENT (LPR)
              </a-select-option>
              <a-select-option value="NONIMMIGRANT">NONIMMIGRANT</a-select-option>
              <a-select-option value="OTHER/I DON'T KNOW">OTHER/I DON'T KNOW</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeImmediateRelativesRecord(3)"/>
          </a-form-model-item>
        </a-col>

      </a-row>
    </a-card>
    <a-card title="工作教育培训信息" style="margin-top: 24px"
            v-if="(moment().diff(model.birthday, 'year', false)) > 12">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="职业类型" prop="primaryOccupation">
            <a-select placeholder="请选择" v-model="form.primaryOccupation">
              <a-select-option value="AGRICULTURE">农业</a-select-option>
              <a-select-option value="ARTIST/PERFORMER">艺术家/表演家</a-select-option>
              <a-select-option value="BUSINESS">商业</a-select-option>
              <a-select-option value="COMMUNICATIONS">通信</a-select-option>
              <a-select-option value="COMPUTER SCIENCE">计算机科学</a-select-option>
              <a-select-option value="CULINARY/FOOD SERVICES">烹饪/食品服务</a-select-option>
              <a-select-option value="EDUCATION">教育</a-select-option>
              <a-select-option value="ENGINEERING">工程</a-select-option>
              <a-select-option value="GOVERNMENT">政府</a-select-option>
              <a-select-option value="HOMEMAKER">家庭主妇</a-select-option>
              <a-select-option value="LEGAL PROFESSION">法律行业</a-select-option>
              <a-select-option value="MEDICAL/HEALTH">医疗/健康</a-select-option>
              <a-select-option value="MILITARY">军事</a-select-option>
              <a-select-option value="NATURAL SCIENCE">自然科学</a-select-option>
              <a-select-option value="NOT EMPLOYED">待业</a-select-option>
              <a-select-option value="PHYSICAL SCIENCES">物理学</a-select-option>
              <a-select-option value="RELIGIOUS VOCATION">宗教职业</a-select-option>
              <a-select-option value="RESEARCH">研究</a-select-option>
              <a-select-option value="RETIRED">退休</a-select-option>
              <a-select-option value="SOCIAL SCIENCE">社会科学</a-select-option>
              <a-select-option value="STUDENT">学生</a-select-option>
              <a-select-option value="OTHER">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="form.primaryOccupation === 'OTHER' || form.primaryOccupation === 'NOT EMPLOYED'">
          <a-form-model-item label="说明" prop="explainOtherPresentOccupation">
            <a-input placeholder="" v-model="form.explainOtherPresentOccupation"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.primaryOccupation !== 'RETIRED' && form.primaryOccupation !== 'NOT EMPLOYED'&& form.primaryOccupation !== 'HOMEMAKER' && form.primaryOccupation">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现工作单位或学校名称" prop="primaryEmployerName">
            <a-input placeholder="eg., Peking University" v-model="form.primaryEmployerName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位月收入(￥)" prop="monthlyIncome">
            <a-input-number placeholder="e,g. 5500" v-model="form.monthlyIncome" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位入职时间" prop="primaryOccupationForStartDate">
            <a-date-picker style="width: 100%" v-model="form.primaryOccupationForStartDate" value-format="YYYY-MM-DD"
                           :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="描述现单位的职责" prop="describeDuties">
            <a-input placeholder="例如 后勤主任" v-model="form.describeDuties"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位电话" prop="primaryOccupationForPhone">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.primaryOccupationForPhone"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.primaryOccupation !== 'RETIRED' && form.primaryOccupation !== 'NOT EMPLOYED'&& form.primaryOccupation !== 'HOMEMAKER' && form.primaryOccupation">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位国家" prop="primaryOccupationForCountry">
            <a-select placeholder="请选择" v-model="form.primaryOccupationForCountry"
                      :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位省份" prop="primaryOccupationForProvince">
            <a-input placeholder="例如 广东" v-model="form.primaryOccupationForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位城市" prop="primaryOccupationForCity">
            <a-input placeholder="例如 广州" v-model="form.primaryOccupationForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位地址" prop="primaryOccupationStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.primaryOccupationStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现单位邮编" prop="primaryOccupationForZipCode">
            <a-input placeholder="例如 00000" v-model="form.primaryOccupationForZipCode"/>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去从事的工作" prop="previouslyEmployed">
            <a-radio-group v-model="form.previouslyEmployed">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.previouslyEmployed === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位名称1" prop="previousEmployerName1">
            <a-input placeholder="例如 ***有限公司" v-model="form.previousEmployerName1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位国家1" prop="previousEmployerCountry1">
            <a-select placeholder="请选择" v-model="form.previousEmployerCountry1" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位省份1" prop="previousEmployerProvince1">
            <a-input placeholder="例如 广东" v-model="form.previousEmployerProvince1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位城市1" prop="previousEmployerCity1">
            <a-input placeholder="例如 广州" v-model="form.previousEmployerCity1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位地址1" prop="previousEmployerStreetAddress1">
            <a-input placeholder="例如 中路100号" v-model="form.previousEmployerStreetAddress1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位邮编1" prop="previousEmployerZipCode1">
            <a-input placeholder="例如 000000" v-model="form.previousEmployerZipCode1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位电话1" prop="previousEmployerTelephone1">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.previousEmployerTelephone1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位担任职务1" prop="previousJobTitle1">
            <a-input placeholder="例如 秘书" v-model="form.previousJobTitle1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位上司姓氏1" prop="previousSupervisorSurname1">
            <a-input placeholder="例如 zhang" v-model="form.previousSupervisorSurname1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位上司名字1" prop="previousSupervisorGivenNames1">
            <a-input placeholder="例如 san" v-model="form.previousSupervisorGivenNames1"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位入职日期1" prop="previousEmploymentStartDate1">
            <a-date-picker style="width: 100%" v-model="form.previousEmploymentStartDate1" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位离职日期1" prop="previousEmploymentEndDate1">
            <a-date-picker style="width: 100%" v-model="form.previousEmploymentEndDate1"
                           :disabled-date="beforePreviousEmployment1"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位工作职责1" prop="previousDescribeDuties1">
            <a-input placeholder="例如 秘书" v-model="form.previousDescribeDuties1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.previousEmployerRecord2 || form.previousEmployerRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addPreviousEmployerRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.previouslyEmployed === 'Yes' && form.previousEmployerRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位名称2" prop="previousEmployerName2">
            <a-input placeholder="例如 ***有限公司" v-model="form.previousEmployerName2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位国家2" prop="previousEmployerCountry2">
            <a-select placeholder="请选择" v-model="form.previousEmployerCountry2" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位省份2" prop="previousEmployerProvince2">
            <a-input placeholder="例如 广东" v-model="form.previousEmployerProvince2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位城市2" prop="previousEmployerCity2">
            <a-input placeholder="例如 广州" v-model="form.previousEmployerCity2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位地址2" prop="previousEmployerStreetAddress2">
            <a-input placeholder="例如 中路100号" v-model="form.previousEmployerStreetAddress2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位邮编2" prop="previousEmployerZipCode2">
            <a-input placeholder="例如 000000" v-model="form.previousEmployerZipCode2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位电话2" prop="previousEmployerTelephone2">
            <a-input placeholder="例如 07565555555(区号+号码)" v-model="form.previousEmployerTelephone2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位担任职务2" prop="previousJobTitle2">
            <a-input placeholder="例如 秘书" v-model="form.previousJobTitle2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位上司姓氏2" prop="previousSupervisorSurname2">
            <a-input placeholder="例如 zhang" v-model="form.previousSupervisorSurname2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位上司名字2" prop="previousSupervisorGivenNames2">
            <a-input placeholder="例如 san" v-model="form.previousSupervisorGivenNames2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位入职日期2" prop="previousEmploymentStartDate2">
            <a-date-picker style="width: 100%" v-model="form.previousEmploymentStartDate2" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位离职日期2" prop="previousEmploymentEndDate2">
            <a-date-picker style="width: 100%" v-model="form.previousEmploymentEndDate2"
                           :disabled-date="beforePreviousEmployment2"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="前单位工作职责2" prop="previousDescribeDuties2">
            <a-input placeholder="例如 秘书" v-model="form.previousDescribeDuties2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removePreviousEmployerRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="中学以上" prop="educationalInstitution">
            <a-radio-group v-model="form.educationalInstitution">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.educationalInstitution === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称1" prop="nameOfInstitution1">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家1" prop="countryOfInstitution1">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution1" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省1" prop="provinceOfInstitution1">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市1" prop="cityOfInstitution1">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址1" prop="streetOfInstitution1">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编1" prop="zipCodeOfInstitution1">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程1" prop="courseOfStudyInstitution1">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution1"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期1" prop="startDateOfInstitution1">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution1" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期1" prop="endDateOfInstitution1">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution1"
                           :disabled-date="beforeDateOfInstitution1"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.educationalInstitutionRecord2 || form.educationalInstitutionRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addEducationalInstitutionRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.educationalInstitution === 'Yes' && form.educationalInstitutionRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称2" prop="nameOfInstitution2">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家2" prop="countryOfInstitution2">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution2" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省2" prop="provinceOfInstitution2">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市2" prop="cityOfInstitution2">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址2" prop="streetOfInstitution2">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编2" prop="zipCodeOfInstitution2">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程2" prop="courseOfStudyInstitution2">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期2" prop="startDateOfInstitution2">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution2" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期2" prop="endDateOfInstitution2">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution2"
                           :disabled-date="beforeDateOfInstitution2"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>


        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.educationalInstitutionRecord3 || form.educationalInstitutionRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addEducationalInstitutionRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeEducationalInstitutionRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.educationalInstitution === 'Yes' && form.educationalInstitutionRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称3" prop="nameOfInstitution3">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家3" prop="countryOfInstitution3">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution3" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省3" prop="provinceOfInstitution3">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市3" prop="cityOfInstitution3">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址3" prop="streetOfInstitution3">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编3" prop="zipCodeOfInstitution3">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution3"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程3" prop="courseOfStudyInstitution3">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution3"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期3" prop="startDateOfInstitution3">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution3" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期3" prop="endDateOfInstitution3">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution3"
                           :disabled-date="beforeDateOfInstitution3"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.educationalInstitutionRecord4 || form.educationalInstitutionRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addEducationalInstitutionRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeEducationalInstitutionRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.educationalInstitution === 'Yes' && form.educationalInstitutionRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称4" prop="nameOfInstitution4">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家4" prop="countryOfInstitution4">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution4" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省4" prop="provinceOfInstitution4">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市4" prop="cityOfInstitution4">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址4" prop="streetOfInstitution4">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编4" prop="zipCodeOfInstitution4">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution4"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程4" prop="courseOfStudyInstitution4">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution4"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期4" prop="startDateOfInstitution4">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution4" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期4" prop="endDateOfInstitution4">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution4"
                           :disabled-date="beforeDateOfInstitution4"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.educationalInstitutionRecord5 || form.educationalInstitutionRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addEducationalInstitutionRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeEducationalInstitutionRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.educationalInstitution === 'Yes' && form.educationalInstitutionRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称5" prop="nameOfInstitution5">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家5" prop="countryOfInstitution5">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution5" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省5" prop="provinceOfInstitution5">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市5" prop="cityOfInstitution5">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址5" prop="streetOfInstitution5">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编5" prop="zipCodeOfInstitution5">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution5"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程5" prop="courseOfStudyInstitution5">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution5"/>
          </a-form-model-item>
        </a-col>


        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期5" prop="startDateOfInstitution5">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution5" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期5" prop="endDateOfInstitution5">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution5"
                           :disabled-date="beforeDateOfInstitution5"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.educationalInstitutionRecord6 || form.educationalInstitutionRecord6 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addEducationalInstitutionRecord(6)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeEducationalInstitutionRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row"
             v-if="form.educationalInstitution === 'Yes' && form.educationalInstitutionRecord6 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾读学校名称6" prop="nameOfInstitution6">
            <a-input placeholder="eg., Peking University" v-model="form.nameOfInstitution6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家6" prop="countryOfInstitution6">
            <a-select placeholder="请选择" v-model="form.countryOfInstitution6" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州/省6" prop="provinceOfInstitution6">
            <a-input placeholder="例如 广东" v-model="form.provinceOfInstitution6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市6" prop="cityOfInstitution6">
            <a-input placeholder="例如 广州" v-model="form.cityOfInstitution6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址6" prop="streetOfInstitution6">
            <a-input placeholder="例如 中路1119号" v-model="form.streetOfInstitution6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮编6" prop="zipCodeOfInstitution6">
            <a-input placeholder="例如 100000" v-model="form.zipCodeOfInstitution6"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="专业/课程6" prop="courseOfStudyInstitution6">
            <a-input placeholder="例如 外贸外语" v-model="form.courseOfStudyInstitution6"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入学日期6" prop="startDateOfInstitution6">
            <a-date-picker style="width: 100%" v-model="form.startDateOfInstitution6" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="毕业日期6" prop="endDateOfInstitution6">
            <a-date-picker style="width: 100%" v-model="form.endDateOfInstitution6"
                           :disabled-date="beforeDateOfInstitution6"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeEducationalInstitutionRecord(6)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="五年内到访国家/地区" prop="traveledToAnyCountries">
            <a-radio-group v-model="form.traveledToAnyCountries">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.traveledToAnyCountries === 'Yes'">
          <a-form-model-item label="到访国家/地区" prop="traveledCountry">
            <a-select mode="multiple"
                      placeholder="请选择"
                      v-model="form.traveledCountry"
                      :filter-option="false"
                      @search="onSearchTraveledCountry"
                      @change="onChangeTraveledCountry"
                      @dropdownVisibleChange="onDropdownVisibleChange"
            >
              <a-select-option v-for="(item, index) in countryOptions" :key="index" :value="item.value"
                               :title="item.text">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="所掌握语言" prop="languageName">
            <a-select placeholder="请选择" mode="multiple" v-model="form.languageName">
              <a-select-option v-for="item in languageList" :key="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="属于宗族,部落或党派" prop="clanTribe">
            <a-radio-group v-model="form.clanTribe">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="参加过慈善组织" prop="belongedToCharitableOrganization">
            <a-radio-group v-model="form.belongedToCharitableOrganization">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="特殊技能或特殊培训" prop="specializedSkill">
            <a-radio-group v-model="form.specializedSkill">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否在军队服役" prop="servedMilitary">
            <a-radio-group v-model="form.servedMilitary">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="军事性单位，治安团体" prop="insurgentOrganization">
            <a-radio-group v-model="form.insurgentOrganization">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>


      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.clanTribe === 'Yes'">
          <a-form-model-item label="属于宗族,部落或党派" prop="clanTribeName">
            <a-input v-model="form.clanTribeName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.belongedToCharitableOrganization === 'Yes'">
          <a-form-model-item label="慈善组织名称" prop="belongToOrganizationName">
            <a-input placeholder="例如 红十字会" v-model="form.belongToOrganizationName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.specializedSkill === 'Yes'">
          <a-form-model-item label="特殊技能,培训原因" prop="specializedSkillExplain">
            <a-input placeholder="请说明原因" v-model="form.specializedSkillExplain"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.insurgentOrganization === 'Yes'">
          <a-form-model-item label="军事,治安单位说明" prop="insurgentOrganizationExplain">
            <a-input placeholder="请作出说明" v-model="form.insurgentOrganizationExplain"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.servedMilitary === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家/地区名称" prop="nameOfCountryMilitary">
            <a-select placeholder="请选择" v-model="form.nameOfCountryMilitary" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="服役部队名称" prop="nameOfMilitary">
            <a-input v-model="form.nameOfMilitary"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="军衔/军职" prop="rankMilitary">
            <a-input v-model="form.rankMilitary"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="军种" prop="branchServiceMilitary">
            <a-input v-model="form.branchServiceMilitary"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="开始服役时间" prop="dateOfServiceFromMilitary">
            <a-date-picker style="width: 100%" v-model="form.dateOfServiceFromMilitary" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="结束服役时间" prop="dateOfServiceToMilitary">
            <a-date-picker style="width: 100%" v-model="form.dateOfServiceToMilitary"
                           :disabled-date="beforeService" value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="临时工作签证信息" style="margin-top: 24px" v-if="form.purposeOfUs === 'L1-L1'">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="公司名称(为你申请)" prop="petitionForCompany">
            <a-input placeholder="eg., apple company" v-model="form.petitionForCompany"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="雇主名称" prop="intendToEmployer">
            <a-input placeholder="eg., san" v-model="form.intendToEmployer"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="州" prop="intendToState">
            <a-select v-model="form.intendToState" placeholder="请选择" :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="城市" prop="intendToCity">
            <a-input v-model="form.intendToCity" placeholder="e.g, Stanford"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址" prop="intendToStreet">
            <a-input v-model="form.intendToStreet" placeholder="e.g, 450 Serra Mall"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址邮编" prop="intendToZipCode">
            <a-input v-model="form.intendToZipCode" placeholder="e.g., 55555"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人手机" prop="intendToPhone">
            <a-input v-model="form.intendToPhone" placeholder="e.g., 5555555555"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="申请人月收入($)" prop="intendToIncome">
            <a-input-number style="width: 100%" v-model="form.intendToIncome" :min="100"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="留学信息" style="margin-top: 24px" v-if="form.purposeOfUs === 'F1-F1'">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人姓氏1(除亲属外)" prop="pocSurname1">
            <a-input placeholder="例如 zhang" v-model="form.pocSurname1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人名字1(除亲属外)" prop="pocGivenName1">
            <a-input placeholder="例如 san" v-model="form.pocGivenName1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在国家1(除亲属外)" prop="pocCountry1">
            <a-select placeholder="请选择" v-model="form.pocCountry1" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在省份1(除亲属外)" prop="pocProvince1">
            <a-input placeholder="例如 广东" v-model="form.pocProvince1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在城市1(除亲属外)" prop="pocCity1">
            <a-input placeholder="例如 广州" v-model="form.pocCity1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在地址1(除亲属外)" prop="pocStreet1">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.pocStreet1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人手机号1(除亲属外)" prop="pocPhone1">
            <a-input-number placeholder="例如 13900000000" v-model="form.pocPhone1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人邮箱1(除亲属外)" prop="pocEmail1">
            <a-input placeholder="例如 visitorinfo@stanford.edu" v-model="form.pocEmail1"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人姓氏2(除亲属外)" prop="pocSurname2">
            <a-input placeholder="例如 zhang" v-model="form.pocSurname2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人名字2(除亲属外)" prop="pocGivenName2">
            <a-input placeholder="例如 san" v-model="form.pocGivenName2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在国家2(除亲属外)" prop="pocCountry2">
            <a-select placeholder="请选择" v-model="form.pocCountry2" :filter-option="filterCountryOption"
                      :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在省份2(除亲属外)" prop="pocProvince2">
            <a-input placeholder="例如 广东" v-model="form.pocProvince2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在城市2(除亲属外)" prop="pocCity2">
            <a-input placeholder="例如 广州" v-model="form.pocCity2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人所在地址2(除亲属外)" prop="pocStreet2">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.pocStreet2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人手机号2(除亲属外)" prop="pocPhone2">
            <a-input-number placeholder="例如 13900000000" v-model="form.pocPhone2" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系人邮箱2(除亲属外)" prop="pocEmail2">
            <a-input placeholder="例如 visitorinfo@stanford.edu" v-model="form.pocEmail2"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="SEVIS ID" prop="sevisId">
            <a-input placeholder="例如 N0123456789" v-model="form.sevisId"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校名称" prop="nameOfSchool">
            <a-input placeholder="" v-model="form.nameOfSchool"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校专业/课程" prop="courseOfSchool">
            <a-input placeholder="" v-model="form.courseOfSchool"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校地址" prop="addressOfSchool">
            <a-input placeholder="" v-model="form.addressOfSchool"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校所在城市" prop="cityOfSchool">
            <a-input placeholder="" v-model="form.cityOfSchool"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校所在州" prop="stateOfSchool">
            <a-select placeholder="请选择" v-model="form.stateOfSchool" :showSearch="true" optionLabelProp="label">
              <a-select-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在美学校邮编" prop="zipCodeOfSchool">
            <a-input placeholder="" v-model="form.zipCodeOfSchool"/>
          </a-form-model-item>
        </a-col>

      </a-row>
    </a-card>
    <a-card title="证件照上传" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="证件照">
            <a-upload
                name="file"
                v-model="form.avatarImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.upload"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="handleChange">
              <img v-if="form.avatarImgUrl" :src="form.avatarImgUrl" alt="avatar" width="150px"/>
              <div v-else>
                <img src="../../assets/no-photo.png" alt="avatar" style="width: 150px"/>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="其他" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="护照送达地址" prop="passportAddress1" :label-col="{ span: 6 }"
                             :wrapper-col="{ span: 18 }">
            <a-input-group compact>
              <a-cascader expand-trigger="hover" :options="passportList" style="width: 30%" placeholder="请选择"
                          v-model="form.passportAddress1" @change="handlePassportAddressChange"/>
              <a-input style="width: 70%" v-model="form.passportAddress2" placeholder="柜台领取不需填"/>
            </a-input-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="资料下载" style="margin-top: 24px;">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <p><a href="https://visa.sancom.online/api/usDs/download/美国B类签证材料清单.docx" target="_blank">美国B类签证材料清单.docx</a>
          </p>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <p><a href="https://visa.sancom.online/api/usDs/download/在职证明 中英文模板1.docx" target="_blank">在职证明
            中英文模板1.docx</a></p>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <p><a href="https://visa.sancom.online/api/usDs/download/在职证明 中英文模板2.docx" target="_blank">在职证明
            中英文模板2.docx</a></p>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <p><a href="https://visa.sancom.online/api/usDs/download/在读证明模板-中英-小中高.docx" target="_blank">在读证明模板-中英-小中高.docx</a>
          </p>
        </a-col>
      </a-row>
    </a-card>
  </a-form-model>
</template>

<script>

import moment from 'moment';
import 'moment/locale/zh-cn';
import {validationRule} from "@/utils/validation-patterns";
import {HttpMixins} from "@/mixins/http-mixins";
import debounce from 'lodash/debounce';


export default {
  name: "DetailCreateTable",
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      page: '',
      model: {},
      form: {},
      config: {},
      chineseName: '个人信息',
      countryOptions: [],
      stateList: [
        {value: 'ALABAMA', label: '阿拉巴马', text: 'ALABAMA 阿拉巴马'},
        {value: 'ALASKA', label: '阿拉斯加', text: 'ALASKA 阿拉斯加'},
        {value: 'AMERICAN SAMOA', label: '美属萨摩亚', text: 'AMERICAN SAMOA 美属萨摩亚'},
        {value: 'ARIZONA', label: '亚利桑那', text: 'ARIZONA 亚利桑那'},
        {value: 'ARKANSAS', label: '阿肯色', text: 'ARKANSAS 阿肯色'},
        {value: 'CALIFORNIA', label: '加州', text: 'CALIFORNIA 加州'},
        {value: 'COLORADO', label: '科罗拉多', text: 'COLORADO 科罗拉多'},
        {value: 'CONNECTICUT', label: '康涅狄格', text: 'CONNECTICUT 康涅狄格'},
        {value: 'DELAWARE', label: '特拉华', text: 'DELAWARE 特拉华'},
        {value: 'DISTRICT OF COLUMBIA', label: '哥伦比亚特区', text: 'DISTRICT OF COLUMBIA 哥伦比亚特区'},
        {value: 'FLORIDA', label: '佛罗里达', text: 'FLORIDA 佛罗里达'},
        {value: 'GEORGIA', label: '乔治亚', text: 'GEORGIA 乔治亚'},
        {value: 'GUAM', label: '关岛', text: 'GUAM 关岛'},
        {value: 'HAWAII', label: '夏威夷', text: 'HAWAII 夏威夷'},
        {value: 'IDAHO', label: '爱达荷', text: 'IDAHO 爱达荷'},
        {value: 'ILLINOIS', label: '伊利诺伊', text: 'ILLINOIS 伊利诺伊'},
        {value: 'INDIANA', label: '印第安纳', text: 'INDIANA 印第安纳'},
        {value: 'IOWA', label: '爱荷华', text: 'IOWA 爱荷华'},
        {value: 'KANSAS', label: '堪萨斯', text: 'KANSAS 堪萨斯'},
        {value: 'KENTUCKY', label: '肯塔基', text: 'KENTUCKY 肯塔基'},
        {value: 'LOUISIANA', label: '路易斯安那', text: 'LOUISIANA 路易斯安那'},
        {value: 'MAINE', label: '缅因', text: 'MAINE 缅因'},
        {value: 'MARYLAND', label: '马里兰', text: 'MARYLAND 马里兰'},
        {value: 'MASSACHUSETTS', label: '马萨诸塞', text: 'MASSACHUSETTS 马萨诸塞'},
        {value: 'MICHIGAN', label: '密歇根', text: 'MICHIGAN 密歇根'},
        {value: 'MINNESOTA', label: '明尼苏达', text: 'MINNESOTA 明尼苏达'},
        {value: 'MISSISSIPPI', label: '密西西比', text: 'MISSISSIPPI 密西西比'},
        {value: 'MISSOURI', label: '密苏里', text: 'MISSOURI 密苏里'},
        {value: 'MONTANA', label: '蒙大拿', text: 'MONTANA 蒙大拿'},
        {value: 'NEBRASKA', label: '内布拉斯加', text: 'NEBRASKA 内布拉斯加'},
        {value: 'NEVADA', label: '内华达', text: 'NEVADA 内华达'},
        {value: 'NEW HAMPSHIRE', label: '新罕布什尔', text: 'NEW HAMPSHIRE 新罕布什尔'},
        {value: 'NEW JERSEY', label: '新泽西', text: 'NEW JERSEY 新泽西'},
        {value: 'NEW MEXICO', label: '新墨西哥', text: 'NEW MEXICO 新墨西哥'},
        {value: 'NEW YORK', label: '纽约', text: 'NEW YORK 纽约'},
        {value: 'NORTH CAROLINA', label: '北卡罗来纳', text: 'NORTH CAROLINA 北卡罗来纳'},
        {value: 'NORTH DAKOTA', label: '北达科他', text: 'NORTH DAKOTA 北达科他'},
        {value: 'NORTHERN MARIANA ISLANDS', label: '北马里亚纳群岛', text: 'NORTHERN MARIANA ISLANDS 北马里亚纳群岛'},
        {value: 'OHIO', label: '俄亥俄', text: 'OHIO 俄亥俄'},
        {value: 'OKLAHOMA', label: '俄克拉荷马', text: 'OKLAHOMA 俄克拉荷马'},
        {value: 'OREGON', label: '俄勒冈', text: 'OREGON 俄勒冈'},
        {value: 'PENNSYLVANIA', label: '宾夕法尼亚', text: 'PENNSYLVANIA 宾夕法尼亚'},
        {value: 'PUERTO RICO', label: '波多黎各', text: 'PUERTO RICO 波多黎各'},
        {value: 'RHODE ISLAND', label: '罗德岛', text: 'RHODE ISLAND 罗德岛'},
        {value: 'SOUTH CAROLINA', label: '南卡罗来纳', text: 'SOUTH CAROLINA 南卡罗来纳'},
        {value: 'SOUTH DAKOTA', label: '南达科他', text: 'SOUTH DAKOTA 南达科他'},
        {value: 'TENNESSEE', label: '田纳西', text: 'TENNESSEE 田纳西'},
        {value: 'TEXAS', label: '德克萨斯', text: 'TEXAS 德克萨斯'},
        {value: 'UTAH', label: '犹他', text: 'UTAH 犹他'},
        {value: 'VERMONT', label: '佛蒙特', text: 'VERMONT 佛蒙特'},
        {value: 'VIRGIN ISLANDS', label: '维尔京群岛', text: 'VIRGIN ISLANDS 维尔京群岛'},
        {value: 'VIRGINIA', label: '维吉尼亚', text: 'VIRGINIA 维吉尼亚'},
        {value: 'WASHINGTON', label: '华盛顿', text: 'WASHINGTON 华盛顿'},
        {value: 'WEST VIRGINIA', label: '西弗吉尼亚', text: 'WEST VIRGINIA 西弗吉尼亚'},
        {value: 'WISCONSIN', label: '威斯康星', text: 'WISCONSIN 威斯康星'},
        {value: 'WYOMING', label: '怀俄明', text: 'WYOMING 怀俄明'}
      ],
      usStatusList: [
        {name: 'S', value: '美国公民'},
        {name: 'C', value: '美国合法永久居留者'},
        {name: 'P', value: '非移民'},
        {name: 'O', value: '其他/我不知道'},
      ],
      yearList: this.getPastYears(10),
      unitTimeList: [
        {name: 'Year(s)', value: '年'},
        {name: 'Month(s)', value: '月'},
        {name: 'Week(s)', value: '周'},
        {name: 'Day(s)', value: '日'}
        // {name: 'Less Than 24 Hours', value: '少于24小时'},
      ],
      socialMediaList: [
        {name: 'QZNE', value: 'QZONE (QQ)'},
        {name: 'SWBO', value: 'SINA WEIBO (新浪微博)'},
        {name: 'YUKU', value: 'YOUKU (优酷)'},
        {name: 'DUBN', value: 'DOUBAN (豆瓣)'},
        {name: 'DOUYIN', value: 'DOUYIN (抖音)'},
        {name: 'WECHAT', value: 'WECHAT (微信)'},
        {name: 'REDNOTE', value: 'REDNOTE (小红书)'},

        {name: 'TIKTOK', value: 'TIKTOK'},
        {name: 'TWIT', value: 'TWITTER (X)'},
        {name: 'FCBK', value: 'FACEBOOK'},
        {name: 'YTUB', value: 'YOUTUBE'},
        {name: 'INST', value: 'INSTAGRAM'},
        {name: 'LINK', value: 'LINKEDIN'},
        {name: 'RDDT', value: 'REDDIT'},
        {name: 'GOOGLE+', value: 'GOOGLE+(Google Currents)'},
      ],
      //TODO: the repeat code
      nationList: [
        {value: 'CHINA', label: '中国', text: 'CHINA 中国'},
        {value: 'MONGOLIA', label: '蒙古', text: 'MONGOLIA 蒙古'},
        {value: 'KOREA, REPUBLIC OF (SOUTH)', label: '韩国', text: 'KOREA, REPUBLIC OF (SOUTH) 韩国'},
        {value: 'JAPAN', label: '日本', text: 'JAPAN 日本'},
        {value: 'TAIWAN', label: '台湾', text: 'TAIWAN 台湾'},
        {value: 'INDIA', label: '印度', text: 'INDIA 印度'},
        {value: 'MALAYSIA', label: '马来西亚', text: 'MALAYSIA 马来西亚'},
        {value: 'MALDIVES', label: '马尔代夫', text: 'MALDIVES 马尔代夫'},
        {value: 'SINGAPORE', label: '新加坡', text: 'SINGAPORE 新加坡'},
        {value: 'THAILAND', label: '泰国', text: 'THAILAND 泰国'},
        {value: 'VIETNAM', label: '越南', text: 'VIETNAM 越南'},
        {value: 'LAOS', label: '老挝', text: 'LAOS 老挝'},
        {value: 'BURMA', label: '缅甸', text: 'BURMA 缅甸'},
        {value: 'BRUNEI', label: '文莱', text: 'BRUNEI 文莱'},
        {value: 'CAMBODIA', label: '柬埔寨', text: 'CAMBODIA 柬埔寨'},
        {value: 'PHILIPPINES', label: '菲律宾', text: 'PHILIPPINES 菲律宾'},
        {value: 'INDONESIA', label: '印度尼西亚', text: 'INDONESIA 印度尼西亚'},
        {value: 'PAKISTAN', label: '巴基斯坦', text: 'PAKISTAN 巴基斯坦'},
        {value: 'FINLAND', label: '芬兰', text: 'FINLAND 芬兰'},
        {value: 'FRANCE', label: '法国', text: 'FRANCE 法国'},
        {value: 'GERMANY', label: '德国', text: 'GERMANY 德国'},
        {value: 'ITALY', label: '意大利', text: 'ITALY 意大利'},
        {value: 'SPAIN', label: '西班牙', text: 'SPAIN 西班牙'},
        {value: 'PORTUGAL', label: '葡萄牙', text: 'PORTUGAL 葡萄牙'},
        {value: 'ICELAND', label: '冰岛', text: 'ICELAND 冰岛'},
        {value: 'GREENLAND', label: '格陵兰岛', text: 'GREENLAND 格陵兰岛'},
        {value: 'UNITED KINGDOM', label: '英国', text: 'UNITED KINGDOM 英国'},
        {value: 'BELGIUM', label: '比利时', text: 'BELGIUM 比利时'},
        {value: 'SWITZERLAND', label: '瑞士', text: 'SWITZERLAND 瑞士'},
        {value: 'SWEDEN', label: '瑞典', text: 'SWEDEN 瑞典'},
        {value: 'GREECE', label: '希腊', text: 'GREECE 希腊'},
        {value: 'GUAM', label: '关岛', text: 'GUAM 关岛'},
        {value: 'NORTH MARIANA ISLANDS', label: '北马里亚纳群岛', text: 'NORTH MARIANA ISLANDS 北马里亚纳群岛'},
        {value: 'AUSTRIA', label: '奥地利', text: 'AUSTRIA 奥地利'},
        {value: 'CZECH REPUBLIC', label: '捷克', text: 'CZECH REPUBLIC 捷克'},
        {value: 'HUNGARY', label: '匈牙利', text: 'HUNGARY 匈牙利'},
        {value: 'POLAND', label: '波兰', text: 'POLAND 波兰'},
        {value: 'NORWAY', label: '挪威', text: 'NORWAY 挪威'},
        {value: 'NETHERLANDS', label: '荷兰', text: 'NETHERLANDS 荷兰'},
        {value: 'DENMARK', label: '丹麦', text: 'DENMARK 丹麦'},
        {value: 'IRELAND', label: '爱尔兰', text: 'IRELAND 爱尔兰'},
        {value: 'CROATIA', label: '克罗地亚', text: 'CROATIA 克罗地亚'},
        {value: 'SERBIA', label: '塞尔维亚', text: 'SERBIA 塞尔维亚'},
        {value: 'ROMANIA', label: '罗马尼亚', text: 'ROMANIA 罗马尼亚'},
        {value: 'LIECHTENSTEIN', label: '列支敦士登', text: 'LIECHTENSTEIN 列支敦士登'},
        {value: 'RUSSIA', label: '俄罗斯', text: 'RUSSIA 俄罗斯'},
        {value: 'UKRAINE', label: '乌克兰', text: 'UKRAINE 乌克兰'},
        {value: 'ISRAEL', label: '以色列', text: 'ISRAEL 以色列'},
        {value: 'CENTRAL AFRICAN REPUBLIC', label: '中非共和国', text: 'CENTRAL AFRICAN REPUBLIC 中非共和国'},
        {value: 'CANADA', label: '加拿大', text: 'CANADA 加拿大'},
        {value: 'UNITED STATES OF AMERICA', label: '美国', text: 'UNITED STATES OF AMERICA 美国'},
        {value: 'MEXICO', label: '墨西哥', text: 'MEXICO 墨西哥'},
        {value: 'BRAZIL', label: '巴西', text: 'BRAZIL 巴西'},
        {value: 'ARGENTINA', label: '阿根廷', text: 'ARGENTINA 阿根廷'},
        {value: 'PERU', label: '秘鲁', text: 'PERU 秘鲁'},
        {value: 'COLOMBIA', label: '哥伦比亚', text: 'COLOMBIA 哥伦比亚'},
        {value: 'CHILE', label: '智利', text: 'CHILE 智利'},
        {value: 'GHANA', label: '加纳', text: 'GHANA 加纳'},
        {value: 'JAMAICA', label: '牙买加', text: 'JAMAICA 牙买加'},
        {value: 'HONDURAS', label: '洪都拉斯', text: 'HONDURAS 洪都拉斯'},
        {value: 'URUGUAY', label: '乌拉圭', text: 'URUGUAY 乌拉圭'},
        {value: 'PARAGUAY', label: '巴拉圭', text: 'PARAGUAY 巴拉圭'},
        {value: 'ARMENIA', label: '亚美尼亚', text: 'ARMENIA 亚美尼亚'},
        {value: 'PANAMA', label: '巴拿马', text: 'PANAMA 巴拿马'},
        {value: 'AUSTRALIA', label: '澳大利亚', text: 'AUSTRALIA 澳大利亚'},
        {value: 'NEW ZEALAND', label: '新西兰', text: 'NEW ZEALAND 新西兰'},
        {value: 'NICARAGUA', label: '尼加拉瓜', text: 'NICARAGUA 尼加拉瓜'},
        {value: 'NIGERIA', label: '尼日利亚', text: 'NIGERIA 尼日利亚'},
        {value: 'EGYPT', label: '埃及', text: 'EGYPT 埃及'},
        {value: 'MOROCCO', label: '摩洛哥', text: 'MOROCCO 摩洛哥'},
        {value: 'FIJI', label: '斐济', text: 'FIJI 斐济'},
        {value: 'SOUTH AFRICA', label: '南非', text: 'SOUTH AFRICA 南非'},
        {value: 'MONACO', label: '摩纳哥', text: 'MONACO 摩纳哥'},
        {value: 'MOZAMBIQUE', label: '莫桑比克', text: 'MOZAMBIQUE 莫桑比克'},
        {value: 'ECUADOR', label: '厄瓜多尔', text: 'ECUADOR 厄瓜多尔'},
        {value: 'UNITED ARAB EMIRATES', label: '阿联酋', text: 'UNITED ARAB EMIRATES 阿联酋'},
        {value: 'QATAR', label: '卡塔尔', text: 'QATAR 卡塔尔'},
        {value: 'SAUDI ARABIA', label: '沙特阿拉伯', text: 'SAUDI ARABIA 沙特阿拉伯'},
        {value: 'OMAN', label: '阿曼', text: 'OMAN 阿曼'},
        {value: 'IRAN', label: '伊朗', text: 'IRAN 伊朗'},
        {value: 'IRAQ', label: '伊拉克共和国', text: 'IRAQ 伊拉克共和国'},
        {value: 'TUNISIA', label: '突尼斯', text: 'TUNISIA 突尼斯'},
        {value: 'TURKEY', label: '土耳其', text: 'TURKEY 土耳其'},
        {value: 'LEBANON', label: '黎巴嫩', text: 'LEBANON 黎巴嫩'},
        {value: 'MONTENEGRO', label: '黑山', text: 'MONTENEGRO 黑山'},
        {value: 'ALBANIA', label: '阿尔巴尼亚', text: 'ALBANIA 阿尔巴尼亚'},
        {value: 'BOSNIA-HERZEGOVINA', label: '波斯尼亚和黑塞哥维那', text: 'BOSNIA-HERZEGOVINA 波斯尼亚和黑塞哥维那'},
        {value: 'SRI LANKA', label: '斯里兰卡', text: 'SRI LANKA 斯里兰卡'},
        {value: 'MACEDONIA, NORTH', label: '北马其顿共和国', text: 'MACEDONIA, NORTH 北马其顿共和国'},
        {value: 'AFGHANISTAN', label: '阿富汗', text: 'AFGHANISTAN 阿富汗'},
        {value: 'ALGERIA', label: '阿尔及利亚', text: 'ALGERIA 阿尔及利亚'},
        {value: 'AMERICAN SAMOA', label: '美洲萨摩亚群岛', text: 'AMERICAN SAMOA 美洲萨摩亚群岛'},
        {value: 'ANDORRA', label: '安道尔', text: 'ANDORRA 安道尔'},
        {value: 'ANGOLA', label: '安哥拉', text: 'ANGOLA 安哥拉'},
        {value: 'ANGUILLA', label: '安圭拉', text: 'ANGUILLA 安圭拉'},
        {value: 'ANTIGUA AND BARBUDA', label: '安提瓜与巴布达', text: 'ANTIGUA AND BARBUDA 安提瓜与巴布达'},
        {value: 'ARUBA', label: '阿鲁巴', text: 'ARUBA 阿鲁巴'},
        {value: 'AZERBAIJAN', label: '阿塞拜疆', text: 'AZERBAIJAN 阿塞拜疆'},
        {value: 'BAHAMAS', label: '巴哈马岛', text: 'BAHAMAS 巴哈马岛'},
        {value: 'BAHRAIN', label: '巴林', text: 'BAHRAIN 巴林'},
        {value: 'BANGLADESH', label: '孟加拉国', text: 'BANGLADESH 孟加拉国'},
        {value: 'BARBADOS', label: '巴巴多斯', text: 'BARBADOS 巴巴多斯'},
        {value: 'BELARUS', label: '白俄罗斯', text: 'BELARUS 白俄罗斯'},
        {value: 'BELIZE', label: '伯利兹', text: 'BELIZE 伯利兹'},
        {value: 'BENIN', label: '贝宁', text: 'BENIN 贝宁'},
        {value: 'BERMUDA', label: '百慕大群岛', text: 'BERMUDA 百慕大群岛'},
        {value: 'BHUTAN', label: '不丹', text: 'BHUTAN 不丹'},
        {value: 'BOLIVIA', label: '玻利维亚', text: 'BOLIVIA 玻利维亚'},
        {value: 'BONAIRE', label: '博奈尔', text: 'BONAIRE 博奈尔'},
        {value: 'BOTSWANA', label: '博茨瓦纳', text: 'BOTSWANA 博茨瓦纳'},
        {value: 'BULGARIA', label: '保加利亚', text: 'BULGARIA 保加利亚'},
        {value: 'BURKINA FASO', label: '布基纳法索', text: 'BURKINA FASO 布基纳法索'},
        {value: 'BURUNDI', label: '布隆迪', text: 'BURUNDI 布隆迪'},
        {value: 'CAMEROON', label: '喀麦隆', text: 'CAMEROON 喀麦隆'},
        {value: 'CABO VERDE', label: '佛得角', text: 'CABO VERDE 佛得角'},
        {value: 'CAYMAN ISLANDS', label: '开曼群岛', text: 'CAYMAN ISLANDS 开曼群岛'},
        {value: 'CHAD', label: '乍得', text: 'CHAD 乍得'},
        {value: 'CHRISTMAS ISLAND', label: '圣诞岛', text: 'CHRISTMAS ISLAND 圣诞岛'},
        {value: 'COCOS KEELING ISLANDS', label: '科科斯群岛', text: 'COCOS KEELING ISLANDS 科科斯群岛'},
        {value: 'COMOROS', label: '科摩罗', text: 'COMOROS 科摩罗'},
        {
          value: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
          label: '刚果（金）',
          text: 'CONGO, DEMOCRATIC REPUBLIC OF THE 刚果（金）'
        },
        {value: 'CONGO, REPUBLIC OF THE', label: '刚果（布）', text: 'CONGO, REPUBLIC OF THE 刚果（布）'},
        {value: 'COOK ISLANDS', label: '库克群岛', text: 'COOK ISLANDS 库克群岛'},
        {value: 'COSTA RICA', label: '哥斯达黎加', text: 'COSTA RICA 哥斯达黎加'},
        {value: 'COTE D`IVOIRE', label: '科特迪瓦', text: 'COTE D`IVOIRE 科特迪瓦'},
        {value: 'CUBA', label: '古巴', text: 'CUBA 古巴'},
        {value: 'CURACAO', label: '库拉索', text: 'CURACAO 库拉索'},
        {value: 'CYPRUS', label: '塞浦路斯', text: 'CYPRUS 塞浦路斯'},
        {value: 'DJIBOUTI', label: '吉布提', text: 'DJIBOUTI 吉布提'},
        {value: 'DOMINICA', label: '多米尼克国', text: 'DOMINICA 多米尼克国'},
        {value: 'DOMINICAN REPUBLIC', label: '多米尼加共和国', text: 'DOMINICAN REPUBLIC 多米尼加共和国'},
        {value: 'EL SALVADOR', label: '萨尔瓦多', text: 'EL SALVADOR 萨尔瓦多'},
        {value: 'EQUATORIAL GUINEA', label: '赤道几内亚', text: 'EQUATORIAL GUINEA 赤道几内亚'},
        {value: 'ERITREA', label: '厄立特里亚', text: 'ERITREA 厄立特里亚'},
        {value: 'ESTONIA', label: '爱沙尼亚', text: 'ESTONIA 爱沙尼亚'},
        {value: 'ESWATINI', label: '斯威士兰', text: 'ESWATINI 斯威士兰'},
        {value: 'ETHIOPIA', label: '埃塞俄比亚', text: 'ETHIOPIA 埃塞俄比亚'},
        {value: 'FALKLAND ISLANDS', label: '福克兰群岛', text: 'FALKLAND ISLANDS 福克兰群岛'},
        {value: 'FAROE ISLANDS', label: '法罗群岛', text: 'FAROE ISLANDS 法罗群岛'},
        {value: 'GABON', label: '加蓬', text: 'GABON 加蓬'},
        {value: 'GAMBIA, THE', label: '冈比亚', text: 'GAMBIA, THE 冈比亚'},
        {value: 'GAZA STRIP', label: '加萨走廊', text: 'GAZA STRIP 加萨走廊'},
        {value: 'GEORGIA', label: '格鲁吉亚', text: 'GEORGIA 格鲁吉亚'},
        {value: 'GIBRALTAR', label: '直布罗陀', text: 'GIBRALTAR 直布罗陀'},
        {value: 'GRENADA', label: '格林纳达', text: 'GRENADA 格林纳达'},
        {value: 'GUADELOUPE', label: '瓜德罗普', text: 'GUADELOUPE 瓜德罗普'},
        {value: 'GUATEMALA', label: '危地马拉', text: 'GUATEMALA 危地马拉'},
        {value: 'GUINEA', label: '几内亚', text: 'GUINEA 几内亚'},
        {value: 'GUINEA - BISSAU', label: '几内亚比绍', text: 'GUINEA - BISSAU 几内亚比绍'},
        {value: 'GUYANA', label: '圭亚那', text: 'GUYANA 圭亚那'},
        {value: 'HAITI', label: '海地', text: 'HAITI 海地'},
        {value: 'HOLY SEE (VATICAN CITY)', label: '梵蒂冈城', text: 'HOLY SEE (VATICAN CITY) 梵蒂冈城'},
        {value: 'JERUSALEM', label: '耶路撒冷', text: 'JERUSALEM 耶路撒冷'},
        {value: 'JORDAN', label: '约旦', text: 'JORDAN 约旦'},
        {value: 'KAZAKHSTAN', label: '哈萨克斯坦', text: 'KAZAKHSTAN 哈萨克斯坦'},
        {value: 'KENYA', label: '肯尼亚', text: 'KENYA 肯尼亚'},
        {value: 'KIRIBATI', label: '基里巴斯', text: 'KIRIBATI 基里巴斯'},
        {value: 'KOSOVO', label: '科索沃', text: 'KOSOVO 科索沃'},
        {value: 'KUWAIT', label: '科威特', text: 'KUWAIT 科威特'},
        {value: 'KYRGYZSTAN', label: '吉尔吉斯斯坦', text: 'KYRGYZSTAN 吉尔吉斯斯坦'},
        {value: 'LATVIA', label: '拉脱维亚', text: 'LATVIA 拉脱维亚'},
        {value: 'LESOTHO', label: '莱索托', text: 'LESOTHO 莱索托'},
        {value: 'LIBERIA', label: '利比里亚', text: 'LIBERIA 利比里亚'},
        {value: 'LIBYA', label: '利比亚', text: 'LIBYA 利比亚'},
        {value: 'LITHUANIA', label: '立陶宛', text: 'LITHUANIA 立陶宛'},
        {value: 'LUXEMBOURG', label: '卢森堡', text: 'LUXEMBOURG 卢森堡'},
        {value: 'MADAGASCAR', label: '马达加斯加', text: 'MADAGASCAR 马达加斯加'},
        {value: 'MALAWI', label: '马拉维', text: 'MALAWI 马拉维'},
        {value: 'MALTA', label: '马耳他', text: 'MALTA 马耳他'},
        {value: 'TANZANIA', label: '坦桑尼亚', text: 'TANZANIA 坦桑尼亚'},
        {value: 'SLOVAKIA', label: '斯洛伐克', text: 'SLOVAKIA 斯洛伐克'},
        {value: 'SLOVENIA', label: '斯洛文尼亚', text: 'SLOVENIA 斯洛文尼亚'},
        {value: 'SOLOMON ISLANDS', label: '所罗门群岛', text: 'SOLOMON ISLANDS 所罗门群岛'},
        {value: 'SOMALIA', label: '索马里', text: 'SOMALIA 索马里'},
        {value: 'SOUTH SUDAN', label: '南苏丹', text: 'SOUTH SUDAN 南苏丹'},
        {value: 'SUDAN', label: '苏丹', text: 'SUDAN 苏丹'},
        {value: 'TAJIKISTAN', label: '塔吉克斯坦', text: 'TAJIKISTAN 塔吉克斯坦'},
        {value: 'TIMOR-LESTE', label: '东帝汶', text: 'TIMOR-LESTE 东帝汶'},
        {value: 'UZBEKISTAN', label: '乌兹别克斯坦', text: 'UZBEKISTAN 乌兹别克斯坦'},
        {value: 'VENEZUELA', label: '委内瑞拉', text: 'VENEZUELA 委内瑞拉'},
        {value: 'YEMEN', label: '也门', text: 'YEMEN 也门'},
        {value: 'ZAMBIA', label: '赞比亚', text: 'ZAMBIA 赞比亚'},
        {value: 'ZIMBABWE', label: '津巴布韦', text: 'ZIMBABWE 津巴布韦'},
        {value: 'NEPAL', label: '尼泊尔', text: 'NEPAL 尼泊尔'}
      ],
      countryList: [
        {value: 'CHINA', label: '中国', text: 'CHINA 中国'},
        {value: 'HONG KONG', label: '香港', text: 'HONG KONG 香港'},
        {value: 'MACAU', label: '澳门', text: 'MACAU 澳门'},
        {value: 'MONGOLIA', label: '蒙古', text: 'MONGOLIA 蒙古'},
        {value: 'KOREA, REPUBLIC OF (SOUTH)', label: '韩国', text: 'KOREA, REPUBLIC OF (SOUTH) 韩国'},
        {value: 'JAPAN', label: '日本', text: 'JAPAN 日本'},
        {value: 'TAIWAN', label: '台湾', text: 'TAIWAN 台湾'},
        {value: 'INDIA', label: '印度', text: 'INDIA 印度'},
        {value: 'MALAYSIA', label: '马来西亚', text: 'MALAYSIA 马来西亚'},
        {value: 'MALDIVES', label: '马尔代夫', text: 'MALDIVES 马尔代夫'},
        {value: 'SINGAPORE', label: '新加坡', text: 'SINGAPORE 新加坡'},
        {value: 'THAILAND', label: '泰国', text: 'THAILAND 泰国'},
        {value: 'VIETNAM', label: '越南', text: 'VIETNAM 越南'},
        {value: 'LAOS', label: '老挝', text: 'LAOS 老挝'},
        {value: 'BURMA', label: '缅甸', text: 'BURMA 缅甸'},
        {value: 'BRUNEI', label: '文莱', text: 'BRUNEI 文莱'},
        {value: 'CAMBODIA', label: '柬埔寨', text: 'CAMBODIA 柬埔寨'},
        {value: 'PHILIPPINES', label: '菲律宾', text: 'PHILIPPINES 菲律宾'},
        {value: 'INDONESIA', label: '印度尼西亚', text: 'INDONESIA 印度尼西亚'},
        {value: 'PAKISTAN', label: '巴基斯坦', text: 'PAKISTAN 巴基斯坦'},
        {value: 'FINLAND', label: '芬兰', text: 'FINLAND 芬兰'},
        {value: 'FRANCE', label: '法国', text: 'FRANCE 法国'},
        {value: 'GERMANY', label: '德国', text: 'GERMANY 德国'},
        {value: 'ITALY', label: '意大利', text: 'ITALY 意大利'},
        {value: 'SPAIN', label: '西班牙', text: 'SPAIN 西班牙'},
        {value: 'PORTUGAL', label: '葡萄牙', text: 'PORTUGAL 葡萄牙'},
        {value: 'ICELAND', label: '冰岛', text: 'ICELAND 冰岛'},
        {value: 'GREENLAND', label: '格陵兰岛', text: 'GREENLAND 格陵兰岛'},
        {value: 'UNITED KINGDOM', label: '英国', text: 'UNITED KINGDOM 英国'},
        {value: 'BELGIUM', label: '比利时', text: 'BELGIUM 比利时'},
        {value: 'SWITZERLAND', label: '瑞士', text: 'SWITZERLAND 瑞士'},
        {value: 'SWEDEN', label: '瑞典', text: 'SWEDEN 瑞典'},
        {value: 'GREECE', label: '希腊', text: 'GREECE 希腊'},
        {value: 'GUAM', label: '关岛', text: 'GUAM 关岛'},
        {value: 'NORTH MARIANA ISLANDS', label: '北马里亚纳群岛', text: 'NORTH MARIANA ISLANDS 北马里亚纳群岛'},
        {value: 'AUSTRIA', label: '奥地利', text: 'AUSTRIA 奥地利'},
        {value: 'CZECH REPUBLIC', label: '捷克', text: 'CZECH REPUBLIC 捷克'},
        {value: 'HUNGARY', label: '匈牙利', text: 'HUNGARY 匈牙利'},
        {value: 'POLAND', label: '波兰', text: 'POLAND 波兰'},
        {value: 'NORWAY', label: '挪威', text: 'NORWAY 挪威'},
        {value: 'PALAU', label: '帕劳', text: 'PALAU 帕劳'},
        {value: 'NETHERLANDS', label: '荷兰', text: 'NETHERLANDS 荷兰'},
        {value: 'DENMARK', label: '丹麦', text: 'DENMARK 丹麦'},
        {value: 'IRELAND', label: '爱尔兰', text: 'IRELAND 爱尔兰'},
        {value: 'CROATIA', label: '克罗地亚', text: 'CROATIA 克罗地亚'},
        {value: 'SERBIA', label: '塞尔维亚', text: 'SERBIA 塞尔维亚'},
        {value: 'ROMANIA', label: '罗马尼亚', text: 'ROMANIA 罗马尼亚'},
        {value: 'LIECHTENSTEIN', label: '列支敦士登', text: 'LIECHTENSTEIN 列支敦士登'},
        {value: 'RUSSIA', label: '俄罗斯', text: 'RUSSIA 俄罗斯'},
        {value: 'UKRAINE', label: '乌克兰', text: 'UKRAINE 乌克兰'},
        {value: 'ISRAEL', label: '以色列', text: 'ISRAEL 以色列'},
        {value: 'CENTRAL AFRICAN REPUBLIC', label: '中非共和国', text: 'CENTRAL AFRICAN REPUBLIC 中非共和国'},
        {value: 'CANADA', label: '加拿大', text: 'CANADA 加拿大'},
        {value: 'UNITED STATES OF AMERICA', label: '美国', text: 'UNITED STATES OF AMERICA 美国'},
        {value: 'MEXICO', label: '墨西哥', text: 'MEXICO 墨西哥'},
        {value: 'BRAZIL', label: '巴西', text: 'BRAZIL 巴西'},
        {value: 'ARGENTINA', label: '阿根廷', text: 'ARGENTINA 阿根廷'},
        {value: 'PERU', label: '秘鲁', text: 'PERU 秘鲁'},
        {value: 'COLOMBIA', label: '哥伦比亚', text: 'COLOMBIA 哥伦比亚'},
        {value: 'CHILE', label: '智利', text: 'CHILE 智利'},
        {value: 'GHANA', label: '加纳', text: 'GHANA 加纳'},
        {value: 'JAMAICA', label: '牙买加', text: 'JAMAICA 牙买加'},
        {value: 'HONDURAS', label: '洪都拉斯', text: 'HONDURAS 洪都拉斯'},
        {value: 'URUGUAY', label: '乌拉圭', text: 'URUGUAY 乌拉圭'},
        {value: 'PARAGUAY', label: '巴拉圭', text: 'PARAGUAY 巴拉圭'},
        {value: 'ARMENIA', label: '亚美尼亚', text: 'ARMENIA 亚美尼亚'},
        {value: 'PANAMA', label: '巴拿马', text: 'PANAMA 巴拿马'},
        {value: 'AUSTRALIA', label: '澳大利亚', text: 'AUSTRALIA 澳大利亚'},
        {value: 'NEW ZEALAND', label: '新西兰', text: 'NEW ZEALAND 新西兰'},
        {value: 'NICARAGUA', label: '尼加拉瓜', text: 'NICARAGUA 尼加拉瓜'},
        {value: 'NIGERIA', label: '尼日利亚', text: 'NIGERIA 尼日利亚'},
        {value: 'EGYPT', label: '埃及', text: 'EGYPT 埃及'},
        {value: 'MOROCCO', label: '摩洛哥', text: 'MOROCCO 摩洛哥'},
        {value: 'FIJI', label: '斐济', text: 'FIJI 斐济'},
        {value: 'SOUTH AFRICA', label: '南非', text: 'SOUTH AFRICA 南非'},
        {value: 'MONACO', label: '摩纳哥', text: 'MONACO 摩纳哥'},
        {value: 'MOZAMBIQUE', label: '莫桑比克', text: 'MOZAMBIQUE 莫桑比克'},
        {value: 'ECUADOR', label: '厄瓜多尔', text: 'ECUADOR 厄瓜多尔'},
        {value: 'UNITED ARAB EMIRATES', label: '阿联酋', text: 'UNITED ARAB EMIRATES 阿联酋'},
        {value: 'QATAR', label: '卡塔尔', text: 'QATAR 卡塔尔'},
        {value: 'SAUDI ARABIA', label: '沙特阿拉伯', text: 'SAUDI ARABIA 沙特阿拉伯'},
        {value: 'OMAN', label: '阿曼', text: 'OMAN 阿曼'},
        {value: 'IRAN', label: '伊朗', text: 'IRAN 伊朗'},
        {value: 'IRAQ', label: '伊拉克共和国', text: 'IRAQ 伊拉克共和国'},
        {value: 'TUNISIA', label: '突尼斯', text: 'TUNISIA 突尼斯'},
        {value: 'TURKEY', label: '土耳其', text: 'TURKEY 土耳其'},
        {value: 'LEBANON', label: '黎巴嫩', text: 'LEBANON 黎巴嫩'},
        {value: 'MONTENEGRO', label: '黑山', text: 'MONTENEGRO 黑山'},
        {value: 'ALBANIA', label: '阿尔巴尼亚', text: 'ALBANIA 阿尔巴尼亚'},
        {value: 'BOSNIA-HERZEGOVINA', label: '波斯尼亚和黑塞哥维那', text: 'BOSNIA-HERZEGOVINA 波斯尼亚和黑塞哥维那'},
        {value: 'SRI LANKA', label: '斯里兰卡', text: 'SRI LANKA 斯里兰卡'},
        {value: 'MACEDONIA, NORTH', label: '北马其顿共和国', text: 'MACEDONIA, NORTH 北马其顿共和国'},
        {value: 'AFGHANISTAN', label: '阿富汗', text: 'AFGHANISTAN 阿富汗'},
        {value: 'ALGERIA', label: '阿尔及利亚', text: 'ALGERIA 阿尔及利亚'},
        {value: 'AMERICAN SAMOA', label: '美洲萨摩亚群岛', text: 'AMERICAN SAMOA 美洲萨摩亚群岛'},
        {value: 'ANDORRA', label: '安道尔', text: 'ANDORRA 安道尔'},
        {value: 'ANGOLA', label: '安哥拉', text: 'ANGOLA 安哥拉'},
        {value: 'ANGUILLA', label: '安圭拉', text: 'ANGUILLA 安圭拉'},
        {value: 'ANTIGUA AND BARBUDA', label: '安提瓜与巴布达', text: 'ANTIGUA AND BARBUDA 安提瓜与巴布达'},
        {value: 'ARUBA', label: '阿鲁巴', text: 'ARUBA 阿鲁巴'},
        {value: 'AZERBAIJAN', label: '阿塞拜疆', text: 'AZERBAIJAN 阿塞拜疆'},
        {value: 'BAHAMAS', label: '巴哈马岛', text: 'BAHAMAS 巴哈马岛'},
        {value: 'BAHRAIN', label: '巴林', text: 'BAHRAIN 巴林'},
        {value: 'BANGLADESH', label: '孟加拉国', text: 'BANGLADESH 孟加拉国'},
        {value: 'BARBADOS', label: '巴巴多斯', text: 'BARBADOS 巴巴多斯'},
        {value: 'BELARUS', label: '白俄罗斯', text: 'BELARUS 白俄罗斯'},
        {value: 'BELIZE', label: '伯利兹', text: 'BELIZE 伯利兹'},
        {value: 'BENIN', label: '贝宁', text: 'BENIN 贝宁'},
        {value: 'BERMUDA', label: '百慕大群岛', text: 'BERMUDA 百慕大群岛'},
        {value: 'BHUTAN', label: '不丹', text: 'BHUTAN 不丹'},
        {value: 'BOLIVIA', label: '玻利维亚', text: 'BOLIVIA 玻利维亚'},
        {value: 'BONAIRE', label: '博奈尔', text: 'BONAIRE 博奈尔'},
        {value: 'BOTSWANA', label: '博茨瓦纳', text: 'BOTSWANA 博茨瓦纳'},
        {value: 'BULGARIA', label: '保加利亚', text: 'BULGARIA 保加利亚'},
        {value: 'BURKINA FASO', label: '布基纳法索', text: 'BURKINA FASO 布基纳法索'},
        {value: 'BURUNDI', label: '布隆迪', text: 'BURUNDI 布隆迪'},
        {value: 'CAMEROON', label: '喀麦隆', text: 'CAMEROON 喀麦隆'},
        {value: 'CABO VERDE', label: '佛得角', text: 'CABO VERDE 佛得角'},
        {value: 'CAYMAN ISLANDS', label: '开曼群岛', text: 'CAYMAN ISLANDS 开曼群岛'},
        {value: 'CHAD', label: '乍得', text: 'CHAD 乍得'},
        {value: 'CHRISTMAS ISLAND', label: '圣诞岛', text: 'CHRISTMAS ISLAND 圣诞岛'},
        {value: 'COCOS KEELING ISLANDS', label: '科科斯群岛', text: 'COCOS KEELING ISLANDS 科科斯群岛'},
        {value: 'COMOROS', label: '科摩罗', text: 'COMOROS 科摩罗'},
        {
          value: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
          label: '刚果（金）',
          text: 'CONGO, DEMOCRATIC REPUBLIC OF THE 刚果（金）'
        },
        {value: 'CONGO, REPUBLIC OF THE', label: '刚果（布）', text: 'CONGO, REPUBLIC OF THE 刚果（布）'},
        {value: 'COOK ISLANDS', label: '库克群岛', text: 'COOK ISLANDS 库克群岛'},
        {value: 'COSTA RICA', label: '哥斯达黎加', text: 'COSTA RICA 哥斯达黎加'},
        {value: 'COTE D`IVOIRE', label: '科特迪瓦', text: 'COTE D`IVOIRE 科特迪瓦'},
        {value: 'CUBA', label: '古巴', text: 'CUBA 古巴'},
        {value: 'CURACAO', label: '库拉索', text: 'CURACAO 库拉索'},
        {value: 'CYPRUS', label: '塞浦路斯', text: 'CYPRUS 塞浦路斯'},
        {value: 'DJIBOUTI', label: '吉布提', text: 'DJIBOUTI 吉布提'},
        {value: 'DOMINICA', label: '多米尼克国', text: 'DOMINICA 多米尼克国'},
        {value: 'DOMINICAN REPUBLIC', label: '多米尼加共和国', text: 'DOMINICAN REPUBLIC 多米尼加共和国'},
        {value: 'EL SALVADOR', label: '萨尔瓦多', text: 'EL SALVADOR 萨尔瓦多'},
        {value: 'EQUATORIAL GUINEA', label: '赤道几内亚', text: 'EQUATORIAL GUINEA 赤道几内亚'},
        {value: 'ERITREA', label: '厄立特里亚', text: 'ERITREA 厄立特里亚'},
        {value: 'ESTONIA', label: '爱沙尼亚', text: 'ESTONIA 爱沙尼亚'},
        {value: 'ESWATINI', label: '斯威士兰', text: 'ESWATINI 斯威士兰'},
        {value: 'ETHIOPIA', label: '埃塞俄比亚', text: 'ETHIOPIA 埃塞俄比亚'},
        {value: 'FALKLAND ISLANDS', label: '福克兰群岛', text: 'FALKLAND ISLANDS 福克兰群岛'},
        {value: 'FAROE ISLANDS', label: '法罗群岛', text: 'FAROE ISLANDS 法罗群岛'},
        {value: 'GABON', label: '加蓬', text: 'GABON 加蓬'},
        {value: 'GAMBIA, THE', label: '冈比亚', text: 'GAMBIA, THE 冈比亚'},
        {value: 'GAZA STRIP', label: '加萨走廊', text: 'GAZA STRIP 加萨走廊'},
        {value: 'GEORGIA', label: '格鲁吉亚', text: 'GEORGIA 格鲁吉亚'},
        {value: 'GIBRALTAR', label: '直布罗陀', text: 'GIBRALTAR 直布罗陀'},
        {value: 'GRENADA', label: '格林纳达', text: 'GRENADA 格林纳达'},
        {value: 'GUADELOUPE', label: '瓜德罗普', text: 'GUADELOUPE 瓜德罗普'},
        {value: 'GUATEMALA', label: '危地马拉', text: 'GUATEMALA 危地马拉'},
        {value: 'GUINEA', label: '几内亚', text: 'GUINEA 几内亚'},
        {value: 'GUINEA - BISSAU', label: '几内亚比绍', text: 'GUINEA - BISSAU 几内亚比绍'},
        {value: 'GUYANA', label: '圭亚那', text: 'GUYANA 圭亚那'},
        {value: 'HAITI', label: '海地', text: 'HAITI 海地'},
        {value: 'HOLY SEE (VATICAN CITY)', label: '梵蒂冈城', text: 'HOLY SEE (VATICAN CITY) 梵蒂冈城'},
        {value: 'JERUSALEM', label: '耶路撒冷', text: 'JERUSALEM 耶路撒冷'},
        {value: 'JORDAN', label: '约旦', text: 'JORDAN 约旦'},
        {value: 'KAZAKHSTAN', label: '哈萨克斯坦', text: 'KAZAKHSTAN 哈萨克斯坦'},
        {value: 'KENYA', label: '肯尼亚', text: 'KENYA 肯尼亚'},
        {value: 'KIRIBATI', label: '基里巴斯', text: 'KIRIBATI 基里巴斯'},
        {value: 'KOSOVO', label: '科索沃', text: 'KOSOVO 科索沃'},
        {value: 'KUWAIT', label: '科威特', text: 'KUWAIT 科威特'},
        {value: 'KYRGYZSTAN', label: '吉尔吉斯斯坦', text: 'KYRGYZSTAN 吉尔吉斯斯坦'},
        {value: 'LATVIA', label: '拉脱维亚', text: 'LATVIA 拉脱维亚'},
        {value: 'LESOTHO', label: '莱索托', text: 'LESOTHO 莱索托'},
        {value: 'LIBERIA', label: '利比里亚', text: 'LIBERIA 利比里亚'},
        {value: 'LIBYA', label: '利比亚', text: 'LIBYA 利比亚'},
        {value: 'LITHUANIA', label: '立陶宛', text: 'LITHUANIA 立陶宛'},
        {value: 'LUXEMBOURG', label: '卢森堡', text: 'LUXEMBOURG 卢森堡'},
        {value: 'MADAGASCAR', label: '马达加斯加', text: 'MADAGASCAR 马达加斯加'},
        {value: 'MALAWI', label: '马拉维', text: 'MALAWI 马拉维'},
        {value: 'MALTA', label: '马耳他', text: 'MALTA 马耳他'},
        {value: 'TANZANIA', label: '坦桑尼亚', text: 'TANZANIA 坦桑尼亚'},
        {value: 'SLOVAKIA', label: '斯洛伐克', text: 'SLOVAKIA 斯洛伐克'},
        {value: 'SLOVENIA', label: '斯洛文尼亚', text: 'SLOVENIA 斯洛文尼亚'},
        {value: 'SOLOMON ISLANDS', label: '所罗门群岛', text: 'SOLOMON ISLANDS 所罗门群岛'},
        {value: 'SOMALIA', label: '索马里', text: 'SOMALIA 索马里'},
        {value: 'SOUTH SUDAN', label: '南苏丹', text: 'SOUTH SUDAN 南苏丹'},
        {value: 'SUDAN', label: '苏丹', text: 'SUDAN 苏丹'},
        {value: 'TAJIKISTAN', label: '塔吉克斯坦', text: 'TAJIKISTAN 塔吉克斯坦'},
        {value: 'TIMOR-LESTE', label: '东帝汶', text: 'TIMOR-LESTE 东帝汶'},
        {value: 'UZBEKISTAN', label: '乌兹别克斯坦', text: 'UZBEKISTAN 乌兹别克斯坦'},
        {value: 'VENEZUELA', label: '委内瑞拉', text: 'VENEZUELA 委内瑞拉'},
        {value: 'YEMEN', label: '也门', text: 'YEMEN 也门'},
        {value: 'ZAMBIA', label: '赞比亚', text: 'ZAMBIA 赞比亚'},
        {value: 'ZIMBABWE', label: '津巴布韦', text: 'ZIMBABWE 津巴布韦'},
        {value: 'ZIMBABWE', label: '津巴布韦', text: 'ZIMBABWE 津巴布韦'},
        {value: 'SEYCHELLES', label: '塞舌尔', text: 'SEYCHELLES 塞舌尔'},
        {value: 'REUNION', label: '留尼汪', text: 'REUNION 留尼汪'},
        {value: 'NEPAL', label: '尼泊尔', text: 'NEPAL 尼泊尔'}
      ],
      languageList: [
        {name: 'CHINESE', value: '汉语'},
        {name: 'ENGLISH', value: '英语'},
        {name: 'JAPANESE', value: '日语'},
        {name: 'SPANISH', value: '西班牙语'},
        {name: 'KOREAN', value: '韩语'},
        {name: 'FRENCH', value: '法语'},
        {name: 'GERMAN', value: '德语'},
        {name: 'RUSSIAN', value: '俄语'}
      ],
      passportList: [
        {
          value: '柜台领取',
          label: '柜台领取',
          children: [
            {
              value: '北京-北京朝阳门北大街8号富华大厦E座1层',
              label: '北京-北京朝阳门北大街8号富华大厦E座1层',
            },
            {
              value: '广州-广州市天河区天河北路233号中信广场东侧首层',
              label: '广州-广州市天河区天河北路233号中信广场东侧首层',
            },
            {
              value: '上海-上海市南京西路1168号中信泰富广场GF',
              label: '上海-上海市南京西路1168号中信泰富广场GF',
            },
            {
              value: '沈阳-沈阳市沈河区大西路336号',
              label: '沈阳-沈阳市沈河区大西路336号',
            },
            {
              value: '武汉-湖北省武汉市江岸区南京路2号',
              label: '武汉-湖北省武汉市江岸区南京路2号',
            }
          ],
        },
        {
          value: '邮寄到家',
          label: '邮寄到家',
          children: [],
        }
      ],
      hotelList: [],
      rules: {
        otherName: [{required: true, message: '必填项'}],
        otherSurname: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        otherGivenName: [
          {required: true, pattern: validationRule.english.pattern, message: validationRule.english.message},
          {validator: this.validOtherGivenName}
        ],
        telecodeName: [{required: true, message: '必填!'}],
        nationalIdentificationNumber: [{
          required: true,
          pattern: validationRule.nationalIdentificationNumber.pattern,
          message: validationRule.nationalIdentificationNumber.message
        }],
        sex: [{required: true, message: '必填!'}],
        maritalStatus: [{required: true, message: '必填!'}],
        dateOfBirth: [{required: true, message: '必填!'}],
        provinceOfBirth: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfBirth: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        purposeOfUs: [{required: true, message: '必填!'}],
        petitionNumber: [{
          required: true,
          pattern: validationRule.numberOrEnglish.pattern,
          message: validationRule.numberOrEnglish.message
        }],
        principleAppSurname: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        principleAppGivenName: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        travelPlans: [{required: true, message: '必填!'}],
        intendedDateOfArrival: [{required: true, message: '必填!'}],
        intendedLengthOfStayNum: [{required: true, type: 'integer', message: '必填,数字!!'}],
        intendedLengthOfStayUnit: [{required: true, message: '必填!'}],
        stateOfStay: [{required: true, message: '必填!'}],
        cityOfStay: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        streetOfStay: [{
          required: true,
          pattern: validationRule.englishAddress.pattern,
          message: validationRule.englishAddress.message
        }],
        zipCodeOfStay: [{pattern: validationRule.usaZipCode.pattern, message: validationRule.usaZipCode.message}],
        dateOfArrival: [{required: true, message: '必填!'}],
        arrivalFlight: [{pattern: validationRule.flightNumber.pattern, message: validationRule.flightNumber.message}],
        arrivalCity: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        dateOfDeparture: [{required: true, message: '必填!'}],
        departureFlight: [{pattern: validationRule.flightNumber.pattern, message: validationRule.flightNumber.message}],
        departureCity: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        planToLocation1: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation2: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation3: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation4: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation5: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation6: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation7: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation8: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation9: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation10: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation11: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation12: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation13: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation14: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation15: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation16: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation17: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation18: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation19: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        planToLocation20: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        payForTrip: [{required: true, message: '必填!'}],
        surnamesOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        telephoneOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.cellphone.pattern,
          message: validationRule.cellphone.message
        }],
        emailOfPersonPayingForTrip: [{type: 'email', message: '输入有误,请检查!'}],
        relationshipOfPersonPayingForTrip: [{required: true, message: '必填!'}],
        sameAddressOfPersonPayingForTrip: [{required: true, message: '必填!'}],
        countryOfPersonPayingForTrip: [{required: true, message: '必填!'}],
        stateOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        zipCodeOfPersonPayingForTrip: [{
          pattern: validationRule.zipCode.pattern,
          message: validationRule.zipCode.message
        }],
        streetOfPersonPayingForTrip: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        nameOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        relationshipOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish1.pattern,
          message: validationRule.numberOrChinaOrEnglish1.message
        }],
        countryOfCompanyPayingForTrip: [{required: true, message: '必填!'}],
        provinceOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfCompanyPayingForTrip: [{
          pattern: validationRule.zipCode.pattern,
          message: validationRule.zipCode.message
        }],
        telephoneOfCompanyPayingForTrip: [{
          required: true,
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }],
        personsTravelingWithYou: [{required: true, message: '必填!'}],
        partOfOrganization: [{required: true, message: '必填!'}],
        nameOfGroupTravelingWithYou: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],

        surnamesOfPersonTravelingWithYou1: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou1: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou1: [{required: true, message: '必填!'}],

        surnamesOfPersonTravelingWithYou2: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou2: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou2: [{required: true, message: '必填!'}],

        surnamesOfPersonTravelingWithYou3: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou3: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou3: [{required: true, message: '必填!'}],

        surnamesOfPersonTravelingWithYou4: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou4: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou4: [{required: true, message: '必填!'}],

        surnamesOfPersonTravelingWithYou5: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou5: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou5: [{required: true, message: '必填!'}],

        surnamesOfPersonTravelingWithYou6: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesOfPersonTravelingWithYou6: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        relationshipWithPersonTravelingWithYou6: [{required: true, message: '必填!'}],

        beanInUs: [{required: true, message: '必填!'}],

        dateArrivedVisits1: [{required: true, message: '必填!'}],
        numLengthOfStayVisits1: [{required: true, type: 'integer', message: '必填,数字格式!!'}],
        unitLengthOfStayVisits1: [{required: true, message: '必填!'}],
        dateArrivedVisits2: [{required: true, message: '必填!'}],
        numLengthOfStayVisits2: [{required: true, type: 'integer', message: '必填,数字格式!!'}],
        unitLengthOfStayVisits2: [{required: true, message: '必填!'}],
        dateArrivedVisits3: [{required: true, message: '必填!'}],
        numLengthOfStayVisits3: [{required: true, type: 'integer', message: '必填,数字!!'}],
        unitLengthOfStayVisits3: [{required: true, message: '必填!'}],
        dateArrivedVisits4: [{required: true, message: '必填!'}],
        numLengthOfStayVisits4: [{required: true, type: 'integer', message: '必填,数字!!'}],
        unitLengthOfStayVisits4: [{required: true, message: '必填!'}],
        dateArrivedVisits5: [{required: true, message: '必填!'}],
        numLengthOfStayVisits5: [{required: true, type: 'integer', message: '必填,数字!!'}],
        unitLengthOfStayVisits5: [{required: true, message: '必填!'}],

        issuedUsVisa: [{required: true, message: '必填!'}],
        previousDateLastVisaWasIssued: [{required: true, message: '必填!'}],
        previousVisaNumber: [{pattern: validationRule.visaNumber.pattern, message: validationRule.visaNumber.message}],
        sameVisa: [{required: true, message: '必填!'}],
        sameCountry: [{required: true, message: '必填!'}],
        tenPrinted: [{required: true, message: '必填!'}],
        lostStolenVisa: [{required: true, message: '必填!'}],
        lostStolenVisaYear: [{required: true, message: '必填!'}],
        lostStolenVisaExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        cancelledRevokedVisa: [{required: true, message: '必填!'}],
        cancelledRevokedVisaExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        refusedVisa: [{required: true, message: '必填!'}],
        refusedVisaExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        behalfWithImmigration: [{required: true, message: '必填!'}],
        behalfWithImmigrationExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        homeAddressForProvince: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        homeAddressForCity: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        homeAddressForStreet: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        homeAddressForZipCode: [{pattern: validationRule.zipCode.pattern, message: validationRule.zipCode.message}],
        sameHomeAddress: [{required: true, message: '必填!'}],
        mailingAddressForProvince: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        mailingAddressForCity: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        mailingAddressForAddress: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        mailingAddressForZipCode: [{pattern: validationRule.zipCode.pattern, message: validationRule.zipCode.message}],
        primaryPhoneNumber: [{
          required: true,
          pattern: validationRule.cellphone.pattern,
          message: validationRule.cellphone.message
        },
          {
            validator: this.validPrimaryPhoneNumber
          }
        ],
        secondaryPhoneNumber: [{
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }, {
          validator: this.validSecondaryPhoneNumber
        }
        ],
        workPhoneNumber: [{
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }, {
          validator: this.validWorkPhoneNumber
        }],
        otherPhoneNumber: [{
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }],
        emailAddress: [{
          required: true,
          type: 'email',
          message: '输入有误,请检查!'
        }, {
          validator: this.validEmailAddress
        }],
        otherEmailAddress: [{
          type: 'email',
          message: '输入有误,请检查!'
        }, {
          validator: this.validOtherEmailAddress
        }],
        otherEmailAddress2: [{
          type: 'email',
          message: '输入有误,请检查!'
        }, {
          validator: this.validOtherEmailAddress
        }],
        otherEmailAddress3: [{
          type: 'email',
          message: '输入有误,请检查!'
        }, {
          validator: this.validOtherEmailAddress
        }],

        passportType: [{required: true, message: '必填!'}],
        passportExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        provinceForPassport: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityForPassport: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        issuanceDateForPassport: [{required: true, message: '必填!'}],
        expirationDateForPassport: [{required: true, message: '必填!'}],

        socialMedia: [{required: true, message: '必填!'}],
        socialMediaPlatform1: [{required: true, message: '必填!'}],
        socialMediaAccount1: [{required: true, message: '必填!'}],
        socialMediaPlatform2: [{required: true, message: '必填!'}],
        socialMediaAccount2: [{required: true, message: '必填!'}],
        socialMediaPlatform3: [{required: true, message: '必填!'}],
        socialMediaAccount3: [{required: true, message: '必填!'}],
        socialMediaPlatform4: [{required: true, message: '必填!'}],
        socialMediaAccount4: [{required: true, message: '必填!'}],
        socialMediaPlatform5: [{required: true, message: '必填!'}],
        socialMediaAccount5: [{required: true, message: '必填!'}],
        socialMediaPlatform6: [{required: true, message: '必填!'}],
        socialMediaAccount6: [{required: true, message: '必填!'}],
        socialMediaPlatform7: [{required: true, message: '必填!'}],
        socialMediaAccount7: [{required: true, message: '必填!'}],
        socialMediaPlatform8: [{required: true, message: '必填!'}],
        socialMediaAccount8: [{required: true, message: '必填!'}],
        socialMediaPlatform9: [{required: true, message: '必填!'}],
        socialMediaAccount9: [{required: true, message: '必填!'}],
        socialMediaPlatform10: [{required: true, message: '必填!'}],
        socialMediaAccount10: [{required: true, message: '必填!'}],

        otherSocialMedia: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform1: [{required: true, message: '必填!'}],
        otherSocialMediaAccount1: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform2: [{required: true, message: '必填!'}],
        otherSocialMediaAccount2: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform3: [{required: true, message: '必填!'}],
        otherSocialMediaAccount3: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform4: [{required: true, message: '必填!'}],
        otherSocialMediaAccount4: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform5: [{required: true, message: '必填!'}],
        otherSocialMediaAccount5: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform6: [{required: true, message: '必填!'}],
        otherSocialMediaAccount6: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform7: [{required: true, message: '必填!'}],
        otherSocialMediaAccount7: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform8: [{required: true, message: '必填!'}],
        otherSocialMediaAccount8: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform9: [{required: true, message: '必填!'}],
        otherSocialMediaAccount9: [{required: true, message: '必填!'}],
        otherSocialMediaPlatform10: [{required: true, message: '必填!'}],
        otherSocialMediaAccount10: [{required: true, message: '必填!'}],

        lostStolenPassport: [{required: true, message: '必填!'}],
        numberForLostStolenPassport: [{
          required: true,
          pattern: validationRule.passportNumber.pattern,
          message: validationRule.passportNumber.message
        }],
        surnamesForContactPerson: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        givenNamesForContactPerson: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        explainForLostStolenPassport: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        passportBookNumber: [{
          pattern: validationRule.numberOrEnglish.pattern,
          message: validationRule.numberOrEnglish.message
        }],
        organizationForContactPerson: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        relationshipMethod: [{required: true, message: '必填!'}],
        socialSecurityNumber: [{
          pattern: validationRule.socialSecurityNumber.pattern,
          message: validationRule.socialSecurityNumber.message
        }],
        taxId: [{pattern: validationRule.taxId.pattern, message: validationRule.taxId.message}],
        hasDriverLicense: [{required: true, message: '必填!'}],
        driverLicenseNumber: [{
          required: true,
          pattern: validationRule.driverLicenseNumber.pattern,
          message: validationRule.driverLicenseNumber.message
        }],
        stateOfDriverLicenseNumber: [{required: true, message: '必填!'}],
        relationshipToYou: [{required: true, message: '必填!'}],
        stateOfContact: [{required: true, message: '必填!'}],
        // ==================== 联系信息验证 ====================
        cityOfContact: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        streetOfContact: [{
          required: true,
          pattern: validationRule.englishAddress.pattern,
          message: validationRule.englishAddress.message
        }],
        zipCodeOfContact: [{pattern: validationRule.usaZipCode.pattern, message: validationRule.usaZipCode.message}],
        phoneOfContact: [{
          required: true,
          pattern: validationRule.usaCellphone.pattern,
          message: validationRule.usaCellphone.message
        }],
        emailOfContact: [{type: 'email', message: '输入有误,请检查!'}],

        // ==================== 父母信息验证 ====================
        fatherSurnames: [{pattern: validationRule.english.pattern, message: validationRule.english.message}],
        fatherGivenNames: [{pattern: validationRule.english.pattern, message: validationRule.english.message}],
        fatherDateOfBirth: [],
        fatherInUs: [],
        fatherStatus: [{required: true, message: '必填!'}],
        motherSurnames: [{pattern: validationRule.english.pattern, message: validationRule.english.message}],
        motherGivenNames: [{pattern: validationRule.english.pattern, message: validationRule.english.message}],
        motherDateOfBirth: [],
        motherInUs: [],
        motherStatus: [{required: true, message: '必填!'}],
        immediateRelatives: [{required: true, message: '必填!'}],
        otherRelatives: [{required: true, message: '必填!'}],

        // ==================== 直系亲属信息验证 ====================
        immediateRelativesSurnames1: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesGivenNames1: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesRelationship1: [{required: true, message: '必填!'}],
        immediateRelativesRelativeStatus1: [{required: true, message: '必填!'}],

        immediateRelativesSurnames2: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesGivenNames2: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesRelationship2: [{required: true, message: '必填!'}],
        immediateRelativesRelativeStatus2: [{required: true, message: '必填!'}],

        immediateRelativesSurnames3: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesGivenNames3: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        immediateRelativesRelationship3: [{required: true, message: '必填!'}],
        immediateRelativesRelativeStatus3: [{required: true, message: '必填!'}],

        // ==================== 当前工作信息验证 ====================
        primaryOccupation: [{required: true, message: '必填!'}],
        explainOtherPresentOccupation: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        primaryEmployerName: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        monthlyIncome: [{required: true, type: 'integer', message: '请输入数字'}],
        primaryOccupationForStartDate: [{required: true, message: '必填!日期不确定可填1号'}],
        describeDuties: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        primaryOccupationForCountry: [{required: true, message: '必填!'}],
        primaryOccupationForProvince: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        primaryOccupationForCity: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        primaryOccupationStreet: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        primaryOccupationForZipCode: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        primaryOccupationForPhone: [{
          required: true,
          pattern: validationRule.phone.pattern,
          message: '必填,请输入正确格式固话号'
        }],
        previouslyEmployed: [{required: true, message: '必填!'}],

        // ==================== 前雇主信息验证（第1个） ====================
        previousEmployerName1: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        previousEmployerCountry1: [{required: true, message: '必填!'}],
        previousEmployerProvince1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        previousEmployerCity1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        previousEmployerStreetAddress1: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        previousEmployerZipCode1: [{pattern: validationRule.zipCode.pattern, message: validationRule.zipCode.message}],
        previousEmployerTelephone1: [{
          required: true,
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }],
        previousJobTitle1: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        previousSupervisorSurname1: [{
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        previousSupervisorGivenNames1: [{
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        previousEmploymentStartDate1: [{required: true, message: '必填!日期不确定可填1号'}],
        previousEmploymentEndDate1: [{required: true, message: '必填!日期不确定可填1号'}],
        previousDescribeDuties1: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],

        // ==================== 前雇主信息验证（第2个） ====================
        previousEmployerName2: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        previousEmployerCountry2: [{required: true, message: '必填!'}],
        previousEmployerProvince2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        previousEmployerCity2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        previousEmployerStreetAddress2: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        previousEmployerZipCode2: [{pattern: validationRule.zipCode.pattern, message: validationRule.zipCode.message}],
        previousEmployerTelephone2: [{
          required: true,
          pattern: validationRule.phone.pattern,
          message: validationRule.phone.message
        }],
        previousJobTitle2: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        previousSupervisorSurname2: [{
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        previousSupervisorGivenNames2: [{
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        previousEmploymentStartDate2: [{required: true, message: '必填!日期不确定可填1号'}],
        previousEmploymentEndDate2: [{required: true, message: '必填!日期不确定可填1号'}],
        previousDescribeDuties2: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],

        // ==================== 教育机构信息验证 ====================
        educationalInstitution: [{required: true, message: '必填!'}],

        // 教育机构1
        nameOfInstitution1: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution1: [{required: true, message: '必填!'}],
        provinceOfInstitution1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution1: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution1: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution1: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution1: [{required: true, message: '必填!日期不确定可填1号'}],

        // ==================== 申请公司信息验证 ====================
        petitionForCompany: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        intendToEmployer: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],

        // ==================== 意向工作地点信息验证 ====================
        intendToState: [{required: true, message: '必填!'}],
        intendToCity: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        intendToStreet: [{
          required: true,
          pattern: validationRule.englishAddress.pattern,
          message: validationRule.englishAddress.message
        }],
        intendToZipCode: [{pattern: validationRule.usaZipCode.pattern, message: validationRule.usaZipCode.message}],
        intendToPhone: [{
          required: true,
          pattern: validationRule.usaCellphone.pattern,
          message: validationRule.usaCellphone.message
        }],
        intendToIncome: [{required: true, type: 'integer', message: '必填,请输入数字!'}],

        // ==================== 紧急联系人信息验证 ====================
        pocSurname1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocGivenName1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocCountry1: [{required: true, message: '必填!'}],
        pocProvince1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocCity1: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocStreet1: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        pocPhone1: [{required: true, type: 'integer', message: '必填,请输入数字'}],
        pocEmail1: [{
          type: 'email',
          message: '输入有误,请检查!'
        }],
        pocSurname2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocGivenName2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocCountry2: [{required: true, message: '必填!'}],
        pocProvince2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocCity2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        pocStreet2: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        pocPhone2: [{required: true, type: 'integer', message: '必填,请输入数字'}],
        pocEmail2: [{
          type: 'email',
          message: '输入有误,请检查!'
        }],

        // ==================== 学校信息验证 ====================
        sevisId: [{required: true, pattern: validationRule.sevisId.pattern, message: validationRule.sevisId.message}],
        nameOfSchool: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        courseOfSchool: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        addressOfSchool: [{
          required: true,
          pattern: validationRule.englishAddress.pattern,
          message: validationRule.englishAddress.message
        }],
        cityOfSchool: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        stateOfSchool: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        zipCodeOfSchool: [{
          required: true,
          pattern: validationRule.usaZipCode.pattern,
          message: validationRule.usaZipCode.message
        }],

        // 教育机构2
        nameOfInstitution2: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution2: [{required: true, message: '必填!'}],
        provinceOfInstitution2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution2: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution2: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution2: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution2: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution2: [{required: true, message: '必填!日期不确定可填1号'}],

        // 教育机构3
        nameOfInstitution3: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution3: [{required: true, message: '必填!'}],
        provinceOfInstitution3: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution3: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution3: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution3: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution3: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution3: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution3: [{required: true, message: '必填!日期不确定可填1号'}],
        // 教育机构4
        nameOfInstitution4: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution4: [{required: true, message: '必填!'}],
        provinceOfInstitution4: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution4: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution4: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution4: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution4: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution4: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution4: [{required: true, message: '必填!日期不确定可填1号'}],

        // 教育机构5
        nameOfInstitution5: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution5: [{required: true, message: '必填!'}],
        provinceOfInstitution5: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution5: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution5: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution5: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution5: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution5: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution5: [{required: true, message: '必填!日期不确定可填1号'}],

        // 教育机构6
        nameOfInstitution6: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        countryOfInstitution6: [{required: true, message: '必填!'}],
        provinceOfInstitution6: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        cityOfInstitution6: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        streetOfInstitution6: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        zipCodeOfInstitution6: [{
          pattern: validationRule.globalZipCode.pattern,
          message: validationRule.globalZipCode.message
        }],
        courseOfStudyInstitution6: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        startDateOfInstitution6: [{required: true, message: '必填!日期不确定可填1号'}],
        endDateOfInstitution6: [{required: true, message: '必填!日期不确定可填1号'}],

        // ==================== 其他信息验证 ====================
        clanTribe: [{required: true, message: '必填!'}],
        clanTribeName: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        languageName: [{required: true, message: '必填!'}],
        traveledToAnyCountries: [{required: true, message: '必填!'}],
        traveledToAnyCountryName: [{required: true, message: '必填!'}],
        belongedToCharitableOrganization: [{required: true, message: '必填!'}],
        belongToOrganizationName: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        specializedSkill: [{required: true, message: '必填!'}],
        specializedSkillExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        servedMilitary: [{required: true, message: '必填!'}],
        nameOfCountryMilitary: [{required: true, message: '必填!'}],
        nameOfMilitary: [{
          required: true,
          pattern: validationRule.orgName.pattern,
          message: validationRule.orgName.message
        }],
        rankMilitary: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        branchServiceMilitary: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        dateOfServiceFromMilitary: [{required: true, message: '必填!'}],
        dateOfServiceToMilitary: [{required: true, message: '必填!'}],
        traveledCountry: [{required: true, message: '必填!'}],
        permanentResidents: [],

        // ==================== 婚姻和配偶信息验证 ====================
        insurgentOrganization: [{required: true, message: '必填!'}],
        maritalOtherExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        spouseSurname: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        spouseGivenName: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        spouseDateOfBirth: [{required: true, message: '必填!'}],
        spouseCountry: [{required: true, message: '必填!'}],
        spouseCountryOfOrigin: [{required: true, message: '必填!'}],
        spouseCityOfBirth: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        spouseAddress: [{required: true, message: '必填!'}],
        spouseAddressOfCountry: [{required: true, message: '必填!'}],
        spouseAddressOfProvince: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        spouseAddressOfCity: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        spouseAddressOfStreet: [{
          required: true,
          pattern: validationRule.address.pattern,
          message: validationRule.address.message
        }],
        spouseAddressOfZipCode: [{pattern: validationRule.zipCode.pattern, message: validationRule.zipCode.message}],

        // ==================== 前配偶信息验证 ====================
        formerSpouseSurname: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        formerSpouseGivenName: [{
          required: true,
          pattern: validationRule.english.pattern,
          message: validationRule.english.message
        }],
        formerSpouseDateOfBirth: [{required: true, message: '必填!'}],
        formerSpouseCountry: [{required: true, message: '必填!'}],
        formerSpouseCityOfBirth: [{
          required: true,
          pattern: validationRule.chinaOrEnglish.pattern,
          message: validationRule.chinaOrEnglish.message
        }],
        formerSpouseStartDate: [{required: true, message: '必填!'}],
        formerSpouseEndDate: [{required: true, message: '必填!'}],
        formerSpouseHowMarriageEnded: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],
        insurgentOrganizationExplain: [{
          required: true,
          pattern: validationRule.numberOrChinaOrEnglish.pattern,
          message: validationRule.numberOrChinaOrEnglish.message
        }],

        // ==================== 文件上传验证 ====================
        avatarImgUrl: [{required: true, message: '请上传图片文件'}],
        passportAddress1: [],
        passportAddress2: []
      },
      url: {
        get: window._CONFIG['domainURL'] + "/power/usDs",
        getConfig: window._CONFIG['domainURL'] + "/user/getConfig",
        launch: window._CONFIG['domainURL'] + "/usDs/launch",
        upload: window._CONFIG['domainURL'] + "/power/uploadFile",
        draftSave: window._CONFIG['domainURL'] + "/power/usDs/draftSave",
      }
    }
  },
  watch: {
    'form.personsTravelingWithYou'(newValue) {
      if (newValue === 'No') {
        delete this.form.partOfOrganization
        delete this.form.nameOfGroupTravelingWithYou
        delete this.form.surnamesOfPersonTravelingWithYou1
        delete this.form.givenNamesOfPersonTravelingWithYou1
        delete this.form.relationshipWithPersonTravelingWithYou1
        delete this.form.surnamesOfPersonTravelingWithYou2
        delete this.form.givenNamesOfPersonTravelingWithYou2
        delete this.form.relationshipWithPersonTravelingWithYou2
        delete this.form.surnamesOfPersonTravelingWithYou3
        delete this.form.givenNamesOfPersonTravelingWithYou3
        delete this.form.relationshipWithPersonTravelingWithYou3
        delete this.form.surnamesOfPersonTravelingWithYou4
        delete this.form.givenNamesOfPersonTravelingWithYou4
        delete this.form.relationshipWithPersonTravelingWithYou4
      }
    },
    'form.travelPlans'(newValue) {
      if (newValue === 'No') {
        delete this.form.dateOfArrival
        delete this.form.arrivalFlight
        delete this.form.arrivalCity
        delete this.form.dateOfDeparture
        delete this.form.departureFlight
        delete this.form.departureCity
        delete this.form.planToLocation1
        delete this.form.planToLocation2
        delete this.form.planToLocation3
        delete this.form.planToLocation4
        delete this.form.planToLocation5
      }
      if (newValue === 'Yes') {
        delete this.form.intendedDateOfArrival
        delete this.form.intendedLengthOfStayNum
        delete this.form.intendedLengthOfStayUnit
      }
    },
    'form.payForTrip'(newValue) {
      if (newValue === 'Self' || newValue === 'Present Employer' || newValue === 'Employer in the U.S.') {
        delete this.form.nameOfCompanyPayingForTrip
        delete this.form.relationshipOfCompanyPayingForTrip
        delete this.form.countryOfCompanyPayingForTrip
        delete this.form.provinceOfCompanyPayingForTrip
        delete this.form.cityOfCompanyPayingForTrip
        delete this.form.streetOfCompanyPayingForTrip
        delete this.form.zipCodeOfCompanyPayingForTrip
        delete this.form.telephoneOfCompanyPayingForTrip

        delete this.form.surnamesOfPersonPayingForTrip
        delete this.form.givenNamesOfPersonPayingForTrip
        delete this.form.telephoneOfPersonPayingForTrip
        delete this.form.emailOfPersonPayingForTrip
        delete this.form.relationshipOfPersonPayingForTrip
        delete this.form.sameAddressOfPersonPayingForTrip
        delete this.form.countryOfPersonPayingForTrip
        delete this.form.stateOfPersonPayingForTrip
        delete this.form.cityOfPersonPayingForTrip
        delete this.form.streetOfPersonPayingForTrip
        delete this.form.zipCodeOfPersonPayingForTrip
      }
      if (newValue === 'Other Person') {
        delete this.form.nameOfCompanyPayingForTrip
        delete this.form.relationshipOfCompanyPayingForTrip
        delete this.form.countryOfCompanyPayingForTrip
        delete this.form.provinceOfCompanyPayingForTrip
        delete this.form.cityOfCompanyPayingForTrip
        delete this.form.streetOfCompanyPayingForTrip
        delete this.form.zipCodeOfCompanyPayingForTrip
        delete this.form.telephoneOfCompanyPayingForTrip
      }
      if (newValue === 'Other Company/Organization') {
        delete this.form.surnamesOfPersonPayingForTrip
        delete this.form.givenNamesOfPersonPayingForTrip
        delete this.form.telephoneOfPersonPayingForTrip
        delete this.form.emailOfPersonPayingForTrip
        delete this.form.relationshipOfPersonPayingForTrip
        delete this.form.sameAddressOfPersonPayingForTrip
        delete this.form.countryOfPersonPayingForTrip
        delete this.form.stateOfPersonPayingForTrip
        delete this.form.cityOfPersonPayingForTrip
        delete this.form.streetOfPersonPayingForTrip
        delete this.form.zipCodeOfPersonPayingForTrip
      }
    },
    'form.relationshipMethod'(newValue) {
      if (newValue === 'person') {
        delete this.form.organizationForContactPerson
      }
      if (newValue === 'organization') {
        delete this.form.surnamesForContactPerson
        delete this.form.givenNamesForContactPerson
      }
    },
  },
  methods: {

    getPastYears(count = 10) {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = count - 1; i >= 0; i--) {
        years.push(String(currentYear - i));
      }
      return years;
    },

    addPlanToLocationRecord() {
      if (!this.form.planToLocationRecord2 || this.form.planToLocationRecord2 === 'No') {
        this.$set(this.form, ['planToLocationRecord2'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord3 || this.form.planToLocationRecord3 === 'No') {
        this.$set(this.form, ['planToLocationRecord3'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord4 || this.form.planToLocationRecord4 === 'No') {
        this.$set(this.form, ['planToLocationRecord4'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord5 || this.form.planToLocationRecord5 === 'No') {
        this.$set(this.form, ['planToLocationRecord5'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord6 || this.form.planToLocationRecord6 === 'No') {
        this.$set(this.form, ['planToLocationRecord6'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord7 || this.form.planToLocationRecord7 === 'No') {
        this.$set(this.form, ['planToLocationRecord7'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord8 || this.form.planToLocationRecord8 === 'No') {
        this.$set(this.form, ['planToLocationRecord8'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord9 || this.form.planToLocationRecord9 === 'No') {
        this.$set(this.form, ['planToLocationRecord9'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord10 || this.form.planToLocationRecord10 === 'No') {
        this.$set(this.form, ['planToLocationRecord10'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord11 || this.form.planToLocationRecord11 === 'No') {
        this.$set(this.form, ['planToLocationRecord11'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord12 || this.form.planToLocationRecord12 === 'No') {
        this.$set(this.form, ['planToLocationRecord12'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord13 || this.form.planToLocationRecord13 === 'No') {
        this.$set(this.form, ['planToLocationRecord13'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord14 || this.form.planToLocationRecord14 === 'No') {
        this.$set(this.form, ['planToLocationRecord14'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord15 || this.form.planToLocationRecord15 === 'No') {
        this.$set(this.form, ['planToLocationRecord15'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord16 || this.form.planToLocationRecord16 === 'No') {
        this.$set(this.form, ['planToLocationRecord16'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord17 || this.form.planToLocationRecord17 === 'No') {
        this.$set(this.form, ['planToLocationRecord17'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord18 || this.form.planToLocationRecord18 === 'No') {
        this.$set(this.form, ['planToLocationRecord18'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord19 || this.form.planToLocationRecord19 === 'No') {
        this.$set(this.form, ['planToLocationRecord19'], 'Yes');
        return;
      }
      if (!this.form.planToLocationRecord20 || this.form.planToLocationRecord20 === 'No') {
        this.$set(this.form, ['planToLocationRecord20'], 'Yes');
        return;
      }
    },
    removePlanToLocationRecord() {
      if (this.form.planToLocationRecord20 && this.form.planToLocationRecord20 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord20'], 'No');
        return;
      }
      if (this.form.planToLocationRecord19 && this.form.planToLocationRecord19 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord19'], 'No');
        return;
      }
      if (this.form.planToLocationRecord18 && this.form.planToLocationRecord18 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord18'], 'No');
        return;
      }
      if (this.form.planToLocationRecord17 && this.form.planToLocationRecord17 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord17'], 'No');
        return;
      }
      if (this.form.planToLocationRecord16 && this.form.planToLocationRecord16 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord16'], 'No');
        return;
      }
      if (this.form.planToLocationRecord15 && this.form.planToLocationRecord15 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord15'], 'No');
        return;
      }
      if (this.form.planToLocationRecord14 && this.form.planToLocationRecord14 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord14'], 'No');
        return;
      }
      if (this.form.planToLocationRecord13 && this.form.planToLocationRecord13 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord13'], 'No');
        return;
      }
      if (this.form.planToLocationRecord12 && this.form.planToLocationRecord12 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord12'], 'No');
        return;
      }
      if (this.form.planToLocationRecord11 && this.form.planToLocationRecord11 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord11'], 'No');
        return;
      }
      if (this.form.planToLocationRecord10 && this.form.planToLocationRecord10 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord10'], 'No');
        return;
      }
      if (this.form.planToLocationRecord9 && this.form.planToLocationRecord9 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord9'], 'No');
        return;
      }
      if (this.form.planToLocationRecord8 && this.form.planToLocationRecord8 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord8'], 'No');
        return;
      }
      if (this.form.planToLocationRecord7 && this.form.planToLocationRecord7 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord7'], 'No');
        return;
      }
      if (this.form.planToLocationRecord6 && this.form.planToLocationRecord6 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord6'], 'No');
        return;
      }
      if (this.form.planToLocationRecord5 && this.form.planToLocationRecord5 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord5'], 'No');
        return;
      }
      if (this.form.planToLocationRecord4 && this.form.planToLocationRecord4 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord4'], 'No');
        return;
      }
      if (this.form.planToLocationRecord3 && this.form.planToLocationRecord3 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord3'], 'No');
        return;
      }
      if (this.form.planToLocationRecord2 && this.form.planToLocationRecord2 === 'Yes') {
        this.$set(this.form, ['planToLocationRecord2'], 'No');
        return;
      }
    },
    addImmediateRelativesRecord(i) {
      this.$set(this.form, ['immediateRelativesRecord' + i], 'Yes');
    },
    removeImmediateRelativesRecord(i) {
      this.$set(this.form, ['immediateRelativesRecord' + i], 'No');
    },
    addBeanInUsRecord(i) {
      this.$set(this.form, ['beanInUsRecord' + i], 'Yes');
    },
    removeBeanInUsRecord(i) {
      this.$set(this.form, ['beanInUsRecord' + i], 'No');
    },
    addSocialMediaRecord(i) {
      this.$set(this.form, ['socialMediaRecord' + i], 'Yes');
    },
    removeSocialMediaRecord(i) {
      this.$set(this.form, ['socialMediaRecord' + i], 'No');
      this.$delete(this.form, 'socialMediaPlatform' + i)
      this.$delete(this.form, 'socialMediaAccount' + i)
    },
    addOtherSocialMediaRecord(i) {
      this.$set(this.form, ['otherSocialMediaRecord' + i], 'Yes');
    },
    removeOtherSocialMediaRecord(i) {
      this.$set(this.form, ['otherSocialMediaRecord' + i], 'No');
      this.$delete(this.form, 'otherSocialMediaPlatform' + i)
      this.$delete(this.form, 'otherSocialMediaAccount' + i)
    },
    addPersonsTravelingWithYouRecord(i) {
      this.$set(this.form, ['personsTravelingWithYouRecord' + i], 'Yes');
    },
    removePersonsTravelingWithYouRecord(i) {
      this.$set(this.form, ['personsTravelingWithYouRecord' + i], 'No');
    },
    addPreviousEmployerRecord(i) {
      this.$set(this.form, ['previousEmployerRecord' + i], 'Yes');
    },
    removePreviousEmployerRecord(i) {
      this.$set(this.form, ['previousEmployerRecord' + i], 'No');
    },
    addEducationalInstitutionRecord(i) {
      this.$set(this.form, ['educationalInstitutionRecord' + i], 'Yes');
    },
    removeEducationalInstitutionRecord(i) {
      this.$set(this.form, ['educationalInstitutionRecord' + i], 'No');
    },

    onSearchCountry: debounce((that, field, value) => {
      if (!value) return;

      that.countryOptions = that.countryList
          .filter(item => item.text.toLowerCase().includes(value.toLowerCase()))
          .map(item => ({text: item.text, value: item.value}));

      that.countryOptions = that.countryOptions.filter(
          item => !(that.form[field] || []).includes(item.value)
      );
    }, 500),

    onChangeCountry(field, value) {
      this.form[field] = value;
      this.countryOptions = this.countryList;
    },

    onSearchTraveledCountry(value) {
      this.onSearchCountry(this, "traveledCountry", value)
    },

    onChangeTraveledCountry(value) {
      this.onChangeCountry("traveledCountry", value)
    },

    onSearchPermanentResidents(value) {
      this.onSearchCountry(this, "permanentResidents", value)
    },

    onChangePermanentResidents(value) {
      this.onChangeCountry("permanentResidents", value)
    },

    onDropdownVisibleChange(open) {
      if (open) {
        // remove China from the country list
        this.countryOptions = this.countryList.slice(1);
      }
    },

    validOtherGivenName(rul, value, callback) {
      if (!value) {
        callback('');
        return;
      }
      if (this.form.otherGivenName &&
          value.toUpperCase() === this.model.givenName.toUpperCase() &&
          this.form.otherSurname &&
          value.toUpperCase() === this.model.surname.toUpperCase()) {
        callback('曾用名与姓不能现用名与姓相同！')
        return;
      }
      callback();
    },
    validEmailAddress(rule, value, callback) {
      if (this.form.otherEmailAddress && value === this.form.otherEmailAddress) {
        callback('邮箱不能相同！')
        return;
      }
      callback();
    },
    validOtherEmailAddress(rule, value, callback) {
      if (this.form.emailAddress && value === this.form.emailAddress) {
        callback('邮箱不能相同！')
        return;
      }
      callback();
    },
    validPrimaryPhoneNumber(rule, value, callback) {
      if (!value) {
        callback('');
        return;
      }
      if (this.form.secondaryPhoneNumber && value === this.form.secondaryPhoneNumber) {
        callback('不能和家庭电话相同！')
        return;
      }
      if (this.form.workPhoneNumber && value === this.form.workPhoneNumber) {
        callback('不能和工作电话相同！')
        return;
      }
      callback();
    },
    validSecondaryPhoneNumber(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (this.form.primaryPhoneNumber && value === this.form.primaryPhoneNumber) {
        callback('不能和手机号相同！')
        return;
      }
      if (this.form.workPhoneNumber && value === this.form.workPhoneNumber) {
        callback('不能和工作电话相同！')
        return;
      }
      callback();
    },
    validWorkPhoneNumber(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (this.form.primaryPhoneNumber && value === this.form.primaryPhoneNumber) {
        callback('不能和手机号相同！')
        return;
      }
      if (this.form.secondaryPhoneNumber && value === this.form.secondaryPhoneNumber) {
        callback('不能和家庭电话相同！')
        return;
      }
      callback();
    },
    beforeService(current) {
      if (this.form.dateOfServiceFromMilitary) {
        return current < moment(this.form.dateOfServiceFromMilitary, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    afterBirthday(current) {
      if (this.model.birthday) {
        return current > moment(this.model.birthday, 'YYYY-MM-DD');
      }
    },
    beforeExpiration(current) {
      if (this.form.issuanceDateForPassport) {
        return current < moment(this.form.issuanceDateForPassport, 'YYYY-MM-DD');
      }
    },
    beforeArrival(current) {
      if (this.form.dateOfArrival) {
        return current < moment(this.form.dateOfArrival, 'YYYY-MM-DD');
      }
    },
    beforeFormerSpouse(current) {
      if (this.form.formerSpouseStartDate) {
        return current < moment(this.form.formerSpouseStartDate, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforePreviousEmployment1(current) {
      if (this.form.previousEmploymentStartDate1) {
        return current < moment(this.form.previousEmploymentStartDate1, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforePreviousEmployment2(current) {
      if (this.form.previousEmploymentStartDate2) {
        return current < moment(this.form.previousEmploymentStartDate2, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution1(current) {
      if (this.form.startDateOfInstitution1) {
        return current < moment(this.form.startDateOfInstitution1, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution2(current) {
      if (this.form.startDateOfInstitution2) {
        return current < moment(this.form.startDateOfInstitution2, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution3(current) {
      if (this.form.startDateOfInstitution3) {
        return current < moment(this.form.startDateOfInstitution3, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution4(current) {
      if (this.form.startDateOfInstitution4) {
        return current < moment(this.form.startDateOfInstitution4, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution5(current) {
      if (this.form.startDateOfInstitution5) {
        return current < moment(this.form.startDateOfInstitution5, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeDateOfInstitution6(current) {
      if (this.form.startDateOfInstitution6) {
        return current < moment(this.form.startDateOfInstitution6, 'YYYY-MM-DD') || current > moment().startOf('day');
      }
    },
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.$set(this.form, ['avatarImgUrl'], '');
      }
      if (info.file.status === 'done') {
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, ['avatarImgUrl'], response.data.url);
        }
      }
    },
    beforeUpload(file) {
      let that = this;
      const isJpg = file.type === 'image/jpeg';
      if (!isJpg) {
        that.$message.error('只支持上传 JPG 格式!');
        return false;
      }
      const isLt200kb = file.size / 1024 < 240;
      if (!isLt200kb) {
        that.$message.error('证件文件大小必须小于 240KB!');
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width < 2400 && img.height < 2400;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file;
      }, () => {
        that.$message.error('上传图片分辨率要小于2400*2400px!');
        return Promise.reject();
      });
      return isSize;
    },
    filterCountryOption(input, option) {
      return (
          option.componentOptions.propsData.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
          option.componentOptions.propsData.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePassportAddressChange(value) {
      if (value[1]) {
        this.form.passportAddress2 = value[1];
      }
    },
    filterHotelOption(input, option) {
      return (
          option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      );
    },
    onSelectHotel(value) {
      const selectedHotel = this.config.usDsHotel.find(hotel => hotel.organizationForContactPerson === value);
      this.form = {...this.form, ...selectedHotel};
    },

    init(id, page, isEn) {

      let that = this;

      this.$refs.targetForm.clearValidate();
      this.model = {};
      this.form = {};
      this.config = {};
      this.hotelList = [];
      this.page = page;
      this.$axios.get(that.url.get + "?id=" + id)
          .then((res) => {
            let data = res.data;
            if (!data) {
              return;
            }
            that.model = Object.assign({}, data);
            that.chineseName = "个人信息（" + that.model.chineseName + "）";

            // eslint-disable-next-line no-debugger
            debugger
            let content = isEn ? that.model.englishContent : that.model.content;
            if (content) {
              that.form = JSON.parse(content);
            }

            /**** Data Compatibility Code *****/
            if (that.form.previousEmploymentDate1 && !that.form.previousEmploymentStartDate1) {
              that.form.previousEmploymentStartDate1 = that.form.previousEmploymentDate1[0];
              that.form.previousEmploymentEndDate1 = that.form.previousEmploymentDate1[1];
            }
            if (that.form.previousEmploymentDate2 && !that.form.previousEmploymentStartDate2) {
              that.form.previousEmploymentStartDate2 = that.form.previousEmploymentDate2[0];
              that.form.previousEmploymentEndDate2 = that.form.previousEmploymentDate2[1];
            }
            if (this.form.dateOfInstitution1 && !that.form.startDateOfInstitution1) {
              that.form.startDateOfInstitution1 = that.form.dateOfInstitution1[0];
              that.form.endDateOfInstitution1 = that.form.dateOfInstitution1[1];
            }
            if (this.form.dateOfInstitution2 && !that.form.startDateOfInstitution2) {
              that.form.startDateOfInstitution2 = that.form.dateOfInstitution2[0];
              that.form.endDateOfInstitution2 = that.form.dateOfInstitution2[1];
            }
            if (this.form.dateOfInstitution3 && !that.form.startDateOfInstitution3) {
              that.form.startDateOfInstitution3 = that.form.dateOfInstitution3[0];
              that.form.endDateOfInstitution3 = that.form.dateOfInstitution3[1];
            }
            if (this.form.dateOfInstitution4 && !that.form.startDateOfInstitution4) {
              that.form.startDateOfInstitution4 = that.form.dateOfInstitution4[0];
              that.form.endDateOfInstitution4 = that.form.dateOfInstitution4[1];
            }
            if (this.form.dateOfInstitution5 && !that.form.startDateOfInstitution5) {
              that.form.startDateOfInstitution5 = that.form.dateOfInstitution5[0];
              that.form.endDateOfInstitution5 = that.form.dateOfInstitution5[1];
            }
            if (this.form.dateOfInstitution6 && !that.form.startDateOfInstitution6) {
              that.form.startDateOfInstitution6 = that.form.dateOfInstitution6[0];
              that.form.endDateOfInstitution6 = that.form.dateOfInstitution6[1];
            }
            /**** Data Compatibility Code *****/

            if ("DetailCreateModal" === page) {
              that.getConfig(that, data.authority);
            }
            that.$emit('emitInit', data);
          });
    },

    getConfig(that, username) {
      that.$axios.get(that.url.getConfig + "?username=" + username, {headers: that.headers})
          .then((res) => {
            let data = res.data;
            if (!data) {
              return;
            }
            that.config = Object.assign({}, data);
            that.initHotelList(that, that.config)
          });
    },

    initHotelList(that, config) {
      if (config.usDsHotel) {
        this.hotelList = this.config.usDsHotel.map(hotel => hotel.organizationForContactPerson);
      }
    },

    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },

    //TODO: 自動保存出
    // handleSilentDraft() {
    //   this.model.content = JSON.stringify(this.form);
    //   this.$axios.put(this.url.draftSave, this.model, {headers: this.headers});
    // },
    handleDraft() {
      const that = this;
      this.model.content = JSON.stringify(this.form);
      this.$refs.targetForm.validate((valid, object) => {
        if (valid) {
          that.model.editProgress = 100
        } else {
          that.model.editProgress = 100 - Object.keys(object).length
        }
        const handleSuccess = (res) => {
          if (res) {
            let response = res.data;
            if (response.code === 200) {
              that.$message.success(response.msg);
              that.$emit('completeDraft', that.model.editProgress);
            } else {
              that.$message.error(response.msg);
            }
          }
        };
        that.$axios.put(that.url.draftSave, that.model, {headers: that.headers})
            .then(handleSuccess)
            .catch((error) => that.catchError(error).then(handleSuccess));
      })
    },
    vailBeforeSubmit(that) {
      if (this.model.chineseName.length > 5 && this.form.telecodeName === 'Yes') {
        this.$message.warning({
          content: '中文姓名电码，请选择否，中文姓名超过5个汉字',
          duration: 8,
        });
        return false
      }
      //证件照
      if (!that.form.avatarImgUrl) {
        that.$message.warning("请上传证件照");
        return false
      }

      //抵达美国
      if (that.form.travelPlans === 'Yes') {
        if (moment(that.form.dateOfArrival, 'YYYY-MM-DD') < moment()) {
          this.$message.warning({
            content: '抵达美国日期不能早于今天',
            duration: 6,
          });
          return false
        }
        if (moment(that.form.dateOfArrival, 'YYYY-MM-DD') > moment(that.form.dateOfDeparture, 'YYYY-MM-DD')) {
          this.$message.warning({
            content: '抵达美国日期不能晚于离开日期',
            duration: 6,
          });
          return false
        }
      } else {
        if (moment(that.form.intendedDateOfArrival, 'YYYY-MM-DD') < moment()) {
          this.$message.warning({
            content: '抵达美国日期不能早于今天',
            duration: 6,
          });
          return false
        }
      }
      //护照日期
      if (moment(that.form.expirationDateForPassport, 'YYYY-MM-DD') < moment()) {
        that.$message.warning("护照有效期有误");
        return false
      }

      return true;
    },
    handleSubmit() {
      const that = this;
      this.$refs.targetForm.validate((valid) => {
        if (valid && that.vailBeforeSubmit(that)) {
          that.$emit('emitBefore');
          that.model.editProgress = 100;
          that.model.content = JSON.stringify(that.form);
          const handleSuccess = (res) => {
            if (res) {
              let response = res.data;
              if (response.code === 200) {
                that.$emit('emitSuccess', that.model.id);
              } else {
                that.$message.error(response.msg);
              }
            }
          };
          that.$axios.put(that.url.launch, that.model, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
              .finally(() => that.$emit('emitFinally'));
        } else {
          that.$message.warning("验证不通过")
        }
      })
    },
  },
  created: {}
}
</script>

<style scoped>

.dynamic-add-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #87d068;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-add-button:hover {
  color: #26cc2a;
}

.dynamic-add-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>
